/**
 * 各种画echarts图表的方法都封装在这里
 * 按需引入 CO₂
 */
/* eslint-disable */
import echarts from 'echarts'
import 'echarts/lib/chart/line'

var clientWidth = document.body.clientWidth
// 字体大小 颜色
const xyTextSize = clientWidth < 1500 ? 10 : 12
const xyTextColor = 'rgba(255,255,255,0.6)'

// 暗底版-碳中和字体与网格线颜色 以 iftxtcolor 传参判断
const darkColor = '#dbdbdb'
const darksplitLine = '#294258'

// 图位置
// const grid = {
//     left: 40,
//     top: 30,
//     right: 40,
//     bottom: 60
// }
// xAxis: [
//     {
//       type: 'category',
//       boundaryGap: false, // 这个属性控制x轴居中或贴近y轴
//       data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
//     }
// ],

const install = function (Vue) {
    Object.defineProperties(Vue.prototype, {
        $chart: {
            get() {
                return {
                    /**
                     * 玫瑰图
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} colors  颜色数组
                     */
                    getMeiGuiPicOption: function (id, name, data, colors, legendShow, iftxtcolor) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!colors) {
                            colors = ['#6ce7df', '#fdd63d', '#ffae02', '#ff7877', '#ff94c2', '#764fce', '#007ed4', '#2297ff', '#35bbff']
                        }
                        if (!legendShow) {
                            legendShow = true
                        }
                        if (!iftxtcolor) {
                            iftxtcolor = true
                        }
                        var legendData = []
                        var seriesD = []
                        data.map(item => {
                            let name =  item.name + '   ' + item.value + '%'
                            var str = {
                                name: name,
                                itemStyle: {
                                    color: 'rgba(' + item.color + ', 1)'
                                },
                                value: item.value
                            }
                            legendData.push(name)
                            seriesD.push(str)
                        })

                        var option = {
                            color: colors,
                            legend: {
                                show: legendShow,
                                orient: 'vertical',
                                icon: 'circle',
                                top: 'center',
                                left: '60%',
                                data: legendData,
                                itemWidth: 10,
                                itemHeight: 20,
                                padding: [0, 5],
                                itemGap: 0,
                                textStyle: {
                                    padding: [5, 5],
                                    fontSize: xyTextSize,
                                    color: iftxtcolor ? darkColor : xyTextColor
                                },
                                formatter: function (name) {
                                    return name
                                }
                            },
                            tooltip: {
                                trigger: 'item',
                                formatter: 
                                function (params, i) {
                                    return params.marker + params.name
                                }
                            },
                            series: [{
                                type: 'pie',
                                radius: ['80%', '80%'],
                                center: ['36%', '50%'],
                                animation: false,
                                z: 0,
                                itemStyle: {
                                    normal: {
                                        color: '#C9C7C7',
                                        label: {
                                            show: false
                                        },
                                        labelLine: {
                                            show: false
                                        },
                                        borderColor: 'rgba(201, 199, 199, .15)',
                                        borderWidth: 1
                                    }
                                },
                                hoverAnimation: false,
                                label: {
                                    show: false
                                },
                                tooltip: {
                                    show: false
                                },
                                data: [100]
                            },{
                                name: '',
                                type: 'pie',
                                radius: ['20%', '75%'],
                                center: ['36%', '50%'],
                                roseType: 'radius',
                                label: {
                                    normal: {
                                        show: false,
                                        position: 'outside',
                                        color: iftxtcolor ? darkColor : xyTextColor,
                                        fontSize: 0
                                    }
                                },
                                labelLine: {
                                    show: false,
                                    length: 0,
                                    length2: 0,
                                    smooth: false
                                },
                                data: seriesD
                            }]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 柱图（分隔）
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} colors  颜色数组
                     */
                    getSeparateBarOption: function (id, name, data, xLabel, colors) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!colors) {
                            colors = ['#6ce7df', '#fdd63d', '#ffae02', '#ff7877', '#ff94c2', '#764fce', '#007ed4', '#2297ff', '#35bbff']
                        }

                        var option = {
                            animation: false,
                            color: colors,
                            grid: [
                                {
                                    left: '0%',
                                    bottom: '0%',
                                    top: '15%',
                                    right: '8%',
                                    containLabel: true
                                }
                            ],
                            legend: {
                                show: false
                            },
                            tooltip: {
                                trigger: 'item',
                                formatter: 
                                function (params) {
                                    return params.name + '：' + params.value + '%'
                                }
                            },
                            xAxis: {
                                data: xLabel,
                                axisLine: {
                                    show: true, //隐藏X轴轴线
                                    lineStyle: {
                                        color: '#11417a',
                                    },
                                },
                                axisTick: {
                                    show: false, //隐藏X轴刻度
                                },
                                axisLabel: {
                                    show: true,
                                    margin: 10,
                                    fontSize: 12,
                                    rotate: 45,
                                    textStyle: {
                                        color: 'rgba(255,255,255,0.6)', //X轴文字颜色
                                    }
                                }
                            },
                            yAxis: [
                                {
                                    name: '吨',
                                    nameTextStyle: {
                                        color: 'rgba(255,255,255,0.6)',
                                        fontSize: xyTextSize,
                                        padding: [0, 0, 0, 0]
                                    },
                                    type: 'value',
                                    gridIndex: 0,
                                    min: 0,
                                    max: 100,
                                    interval: 25,
                                    // splitNumber: 4,
                                    splitLine: {
                                        show: true,
                                        lineStyle: {
                                            color: 'rgba(255,255,255,0.5)',
                                            width: .5,
                                        },
                                    },
                                    axisTick: {
                                        show: false,
                                    },
                                    axisLine: {
                                        show: false,
                                        lineStyle: {
                                            color: '#11417a',
                                        },
                                    },
                                    axisLabel: {
                                        show: true,
                                        margin: 14,
                                        fontSize: 10,
                                        textStyle: {
                                            color: 'rgba(255,255,255,0.6)', //X轴文字颜色
                                        },
                                    },
                                },
                            ],
                            series: [
                                {
                                    // 值
                                    name: '采集覆盖率情况',
                                    type: 'bar',
                                    barWidth: 10,
                                    itemStyle: {
                                        normal: {
                                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                {
                                                    offset: 0,
                                                    color: '#FDD790',
                                                },
                                                {
                                                    offset: 1,
                                                    color: '#FFAD14',
                                                },
                                            ]),
                                        },
                                    },
                                    data: data,
                                    z: 10,
                                    zlevel: 2,
                                    label: {
                                        show: false,
                                        position: 'top',
                                        distance: 10,
                                        fontSize: 12,
                                        fontFamily:'DIN',
                                        color: '#ffffff',
                                        zlevel: 4,
                                        z: 10,
                                        formatter:'{c}%'
                                    },
                                },
                                {
                                    // 值分隔
                                    type: 'pictorialBar',
                                    itemStyle: {
                                        normal: {
                                            color: '#0F375F',
                                        },
                                    },
                                    symbolRepeat: 'fixed',
                                    symbolMargin: 2,
                                    symbol: 'rect',
                                    symbolClip: true,
                                    symbolSize: [10, 2],
                                    symbolPosition: 'start',
                                    symbolOffset: [0, -1],
                                    // symbolBoundingData: this.total,
                                    data: data,
                                    width: 25,
                                    z: 0,
                                    zlevel: 3,
                                }
                            ]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 饼图
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} colors  颜色数组
                     */
                    getSeparatePieOption: function (id, name, data) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        let colors = ['rgba(91, 143, 249, 1)', 'rgba(90, 216, 166, 1)', 'rgba(246, 189, 22, 1)']
                        let colors1 = ['91, 143, 249', '90, 216, 166', '246, 189, 22']
                        
                        let legendData = []
                        let dataPush = [];
                        let list = {};
                        data.forEach((item, index) => {
                            list = {
                                value: item.value,
                                name: item.name +'：' + item.value + '吨',
                                label: {
                                    show: false,
                                },
                                labelLine: {
                                    show: false,
                                },
                                itemStyle: {
                                    borderColor: colors[index],
                                    borderWidth: 1,
                                    color: 'rgba(' +colors1[index] + ', 0.2)',
                                },
                            };
                            dataPush.push(list);
                            legendData.push(item.name +'：'+ item.value + '吨');
                        });
                        var option = {
                            animation: false,
                            color: colors,
                            grid: [
                                {
                                    left: '0%',
                                    bottom: '0%',
                                    top: '15%',
                                    right: '8%',
                                    containLabel: true
                                }
                            ],
                            legend: {
                                show: true,
                                orient: 'vertical',
                                icon: 'circle',
                                top: 'center',
                                left: '60%',
                                data: legendData,
                                itemWidth: 10,
                                itemHeight: 20,
                                padding: [0, 5],
                                itemGap: 0,
                                textStyle: {
                                    padding: [5, 5],
                                    fontSize: xyTextSize,
                                    color: xyTextColor
                                },
                                formatter: function (name) {
                                    return name
                                }
                            },
                            tooltip: {
                                trigger: 'item',
                                formatter: 
                                function (params) {
                                    return params.name + '：' + params.value + '%'
                                }
                            },
                            series: [
                                {
                                  name: '01',
                                  type: 'pie',
                                  radius: ['77%', '80%'],
                                  center: ['33%', '50%'],
                                  avoidLabelOverlap: false,
                                  hoverAnimation: false,
                                  startAngle: 0,
                                  itemStyle: {
                                    borderWidth: 2,
                                  },
                                  label: {
                                    show: false,
                                  },
                                  labelLine: {
                                    show: false,
                                  },
                                  data: data,
                                },
                                {
                                  name: '02',
                                  type: 'pie',
                                  radius: ['45%', '77%'],
                                  center: ['33%', '50%'],
                                  avoidLabelOverlap: false,
                                  hoverAnimation: false,
                                  startAngle: 0,
                                  label: {
                                    show: false
                                  },
                                  labelLine: {
                                    show: true,
                                    length: 40,
                                    length2: 120,
                                    lineStyle: {
                                      width: 1,
                                    },
                                  },
                                  // itemStyle: {
                                  //   shadowBlur: 20,
                                  //   shadowColor: '#25fffd',
                                  // },
                                  data: dataPush,
                                },
                                {
                                  name: '03',
                                  type: 'pie',
                                  radius: ['30%', '31%'],
                                  center: ['33%', '50%'],
                                  avoidLabelOverlap: false,
                                  hoverAnimation: false,
                                  startAngle: 0,
                                  itemStyle: {
                                    borderWidth: 2,
                                  },
                                  label: {
                                    show: false,
                                  },
                                  labelLine: {
                                    show: false,
                                  },
                                  data: data,
                                },
                                {
                                  type: 'pie',
                                  radius: ['8%', '20%'],
                                  center: ['33%', '50%'],
                                  avoidLabelOverlap: false,
                                  hoverAnimation: false,
                                  label: {
                                    position: 'center',
                                    color: '#fff',
                                    padding: [-80, -100],
                                    fontSize: 30,
                                    formatter: (params) => {
                                      return `${params.name}\n\n\n`;
                                    },
                                  },
                                  itemStyle: {
                                    color: '#1FDFDF',
                                    emphasis: {
                                      color: '#1FDFDF', // RGBA(11,38,80,0.5)
                                    },
                                  },
                                  data: [{ value: 100, name: '' }],
                                },
                            ]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)
                        // 图例点击事件
                        // this.chart.on('legendselectchanged', function (obj) {
                        //     console.log(obj)
                        // })


                        return this.chart
                    },
                    /**
                     * 立体柱线图(圆形)
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} xData  x轴数据
                     * @param {*} colors  颜色数组
                     * @param {*} legendShow  是否显示图例
                     */
                    getBar3DOption(id, name, data, xData, colors, legendShow) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!colors) {
                            colors = ['#5b9bd5', '#ed7d31', '#a5a5a5', '#ffc003', '#4472c4', '#70ad47']
                        }
                        var lengthData = []
                        // var BARNUM = data.length > 0 ? data[0].data : []
                        // var LINENUM = data.length > 0 ? data[1].data : []

                        data.map(item => {
                            lengthData.push(item.name)
                        })

                        let option = {
                            grid: {
                                top: '14%',
                                left: '1%',
                                bottom: '0%',
                                right: '1%',
                                containLabel: true
                            },
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'cross',
                                    crossStyle: {
                                        color: '#999'
                                    }
                                },
                                formatter: function (params) {
                                    var html = '<div>'
                                    html += '   <span style="color:#fff">' + params[0].name + '</span> <br/>'
                                    params.map((item, i) => {
                                        if (i > 1) {
                                            i === 3 ? html += params[i].marker : html += "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#72FEFE;'></span>"
                                            html += '   <span style="color:#fff">' + params[i].seriesName + '</span>'
                                            html += '   <span style="color:#fff">：' + params[i].data + data[i-2].dw +'</span> <br/>'
                                        }
                                    })
                                    html += '</div>'

                                    return html
                                }
                            },
                            xAxis: {
                                data: xData,
                                type: 'category',
                                axisTick: {
                                    show: false,
                                    lineStyle: {
                                        color: 'rgba(255,255,255,0.5)'
                                    }
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: 'rgba(255,255,255,0.3)',
                                        width: .5,
                                    }
                                },
                                axisLabel: {
                                    textStyle: {
                                        color: xyTextColor
                                    },
                                    margin: 20
                                }
                            },
                            legend: {
                                show: true,
                                data: lengthData,
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: xyTextColor
                                }
                            },
                            yAxis: [{
                                type: 'value',
                                name: '吨',
                                min: 0,
                                // max: (parseInt(Math.max(...BARNUM) / 100) + 1) * 100, // 取最大值为最大刻度
                                position: 'left',
                                axisLine: {
                                    show: false,
                                    lineStyle: {
                                        color: xyTextColor
                                    }
                                },
                                axisTick: {
                                    show: false, //隐藏X轴刻度
                                },
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        color: 'rgba(255,255,255,0.5)',
                                        width: .5,
                                    }
                                },
                                axisLabel: {
                                    show: true,
                                    color: xyTextColor,
                                    fontSize: xyTextSize,
                                    formatter: '{value}'
                                }
                            }, {
                                type: 'value',
                                name: '元',
                                min: 0,
                                // max: (parseInt(Math.max(...LINENUM) / 100) + 1) < 10 ? (parseInt(Math.max(...LINENUM) / 100) + 1) * 10 : (parseInt(Math.max(...LINENUM) / 100) + 1) * 100, // 取最大值为最大刻度
                                position: 'right',
                                axisLine: {
                                    show: false,
                                    lineStyle: {
                                        color: xyTextColor
                                    }
                                },
                                axisTick: {
                                    show: false, //隐藏X轴刻度
                                },
                                splitLine: {
                                    show: false
                                },
                                axisLabel: {
                                    show: true,
                                    color: xyTextColor,
                                    fontSize: xyTextSize,
                                    formatter: '{value}'
                                }
                            }],
                            series: [{
                                name: '每月交易碳减排量数3', // top
                                type: 'pictorialBar',
                                symbolSize: [15, 10],
                                symbolOffset: [0, -6],
                                symbolPosition: 'end',
                                z: 12,
                                label: {
                                    normal: {
                                        show: true,
                                        position: 'top',
                                        formatter: '',
                                        fontSize: 25,
                                        fontWeight: 'bold',
                                        color: '#fff'
                                    }
                                },
                                color: '#5CFFFE',
                                data: data[0].data
                            }, {
                                name: '每月交易碳减排量数2', // bottom
                                type: 'pictorialBar',
                                symbolSize: [15, 10],
                                symbolOffset: [0, 5],
                                z: 12,
                                color: '#72FEFE',
                                data: data[0].data
                            }, {
                                name: data[0].name,
                                type: 'bar',
                                itemStyle: {
                                    normal: {
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 0.7, [{
                                            offset: 0,
                                            color: '#0ED9D8'
                                        },
                                        {
                                            offset: 1,
                                            color: '#72FEFE'
                                        }
                                        ]),
                                        opacity: 1
                                    }
                                },
                                silent: true,
                                barWidth: 15,
                                barGap: '-100%', // Make series be overlap
                                data: data[0].data
                            }, {
                                name: data[1].name,
                                type: 'line',
                                symbol: 'circle',
                                symbolSize: 0,
                                itemStyle: {
                                    normal: {
                                        color: '#F6BD16',
                                        opacity: 1
                                    }
                                },
                                areaStyle: {
                                    normal: {
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                            offset: 0,
                                            color: 'rgba(246, 189, 22, .3)'
                                        }, {
                                            offset: 0.8,
                                            color: 'rgba(246, 189, 22, .3)'
                                        }], false),
                                        shadowColor: 'rgba(0, 0, 0, 0.1)',
                                        shadowBlur: 10
                                    }
                                },
                                yAxisIndex: 1,
                                barGap: '-100%', // Make series be overlap
                                data: data[1].data
                            }]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 面积图（单线）（双线）
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} xData  x轴数据
                     * @param {*} colors  颜色数组
                     * @param {*} legendShow  是否显示图例
                     */
                    getOneLineAreaOption(id, name, data, xData, colors, legendShow) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!colors) {
                            colors = ['#5b9bd5', '#ed7d31', '#a5a5a5', '#ffc003', '#4472c4', '#70ad47']
                        }
                        var lengthData = []
                        // var BARNUM = data.length > 0 ? data[0].data : []
                        // var LINENUM = data.length > 0 ? data[1].data : []

                        data.map(item => {
                            lengthData.push(item.name)
                        })

                        let option = {
                            grid: {
                                top: '14%',
                                left: '1%',
                                bottom: '0%',
                                right: '1%',
                                containLabel: true
                            },
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'cross',
                                    crossStyle: {
                                        color: '#999'
                                    }
                                },
                                formatter: function (params) {
                                    var html = '<div>'
                                    html += '   <span style="color:#fff">' + params[0].name + '</span> <br/>'
                                    params.map((item, i) => {
                                        if (i > 1) {
                                            i === 3 ? html += params[i].marker : html += "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#72FEFE;'></span>"
                                            html += '   <span style="color:#fff">' + params[i].seriesName + '</span>'
                                            html += '   <span style="color:#fff">：' + params[i].data + data[i-2].dw +'</span> <br/>'
                                        }
                                    })
                                    html += '</div>'

                                    return html
                                }
                            },
                            xAxis: {
                                data: xData,
                                type: 'category',
                                boundaryGap: false,
                                axisTick: {
                                    show: false,
                                    lineStyle: {
                                        color: 'rgba(255,255,255,0.5)'
                                    }
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: 'rgba(255,255,255,0.3)',
                                        width: .5,
                                    }
                                },
                                axisLabel: {
                                    textStyle: {
                                        color: xyTextColor
                                    },
                                    margin: 20
                                }
                            },
                            legend: {
                                show: false,
                                icon: "roundRect",
                                itemHeight: 2,
                                itemWidth: 8,
                                data: lengthData,
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: xyTextColor
                                }
                            },
                            yAxis: [{
                                type: 'value',
                                name: data[0].dw,
                                min: 0,
                                // max: (parseInt(Math.max(...BARNUM) / 100) + 1) * 100, // 取最大值为最大刻度
                                position: 'left',
                                axisLine: {
                                    show: false,
                                    lineStyle: {
                                        color: xyTextColor
                                    }
                                },
                                axisTick: {
                                    show: false, //隐藏X轴刻度
                                },
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        color: 'rgba(255,255,255,0.5)',
                                        width: .5,
                                    }
                                },
                                axisLabel: {
                                    show: true,
                                    color: xyTextColor,
                                    fontSize: xyTextSize,
                                    formatter: '{value}'
                                }
                            }],
                            series: [{
                                name: data[0].name,
                                type: 'line',
                                symbol: 'circle',
                                symbolSize: 0,
                                itemStyle: {
                                    normal: {
                                        color: 'rgba(' + data[0].color + ', 1)',
                                        opacity: 1
                                    }
                                },
                                areaStyle: {
                                    normal: {
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                            offset: 0,
                                            color: 'rgba(' + data[0].color + ', .3)'
                                        }, {
                                            offset: 0.8,
                                            color: 'rgba(' + data[0].color + ', .3)'
                                        }], false),
                                        shadowColor: 'rgba(0, 0, 0, 0.1)',
                                        shadowBlur: 10
                                    }
                                },
                                yAxisIndex: 0,
                                data: data[0].data
                            }]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    getTwoLineAreaOption(id, name, data, xData, colors, legendShow) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!colors) {
                            colors = ['#5b9bd5', '#ed7d31', '#a5a5a5', '#ffc003', '#4472c4', '#70ad47']
                        }
                        var lengthData = []
                        // var BARNUM = data.length > 0 ? data[0].data : []
                        // var LINENUM = data.length > 0 ? data[1].data : []

                        data.map(item => {
                            lengthData.push(item.name)
                        })

                        let option = {
                            grid: {
                                top: '14%',
                                left: '1%',
                                bottom: '0%',
                                right: '1%',
                                containLabel: true
                            },
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'cross',
                                    crossStyle: {
                                        color: '#999'
                                    }
                                },
                                formatter: function (params) {
                                    var html = '<div>'
                                    html += '   <span style="color:#fff">' + params[0].name + '</span> <br/>'
                                    params.map((item, i) => {
                                        if (i > 1) {
                                            i === 3 ? html += params[i].marker : html += "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#72FEFE;'></span>"
                                            html += '   <span style="color:#fff">' + params[i].seriesName + '</span>'
                                            html += '   <span style="color:#fff">：' + params[i].data + data[i-2].dw +'</span> <br/>'
                                        }
                                    })
                                    html += '</div>'

                                    return html
                                }
                            },
                            xAxis: {
                                data: xData,
                                type: 'category',
                                boundaryGap: false,
                                axisTick: {
                                    show: false,
                                    lineStyle: {
                                        color: 'rgba(255,255,255,0.5)'
                                    }
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: 'rgba(255,255,255,0.3)',
                                        width: .5,
                                    }
                                },
                                axisLabel: {
                                    textStyle: {
                                        color: xyTextColor
                                    },
                                    margin: 20
                                }
                            },
                            legend: {
                                show: true,
                                icon: "roundRect",
                                itemHeight: 2,
                                itemWidth: 8,
                                data: lengthData,
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: xyTextColor
                                }
                            },
                            yAxis: [{
                                type: 'value',
                                name: data[0].dw,
                                min: 0,
                                // max: (parseInt(Math.max(...BARNUM) / 100) + 1) * 100, // 取最大值为最大刻度
                                position: 'left',
                                axisLine: {
                                    show: false,
                                    lineStyle: {
                                        color: xyTextColor
                                    }
                                },
                                axisTick: {
                                    show: false, //隐藏X轴刻度
                                },
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        color: 'rgba(255,255,255,0.5)',
                                        width: .5,
                                    }
                                },
                                axisLabel: {
                                    show: true,
                                    color: xyTextColor,
                                    fontSize: xyTextSize,
                                    formatter: '{value}'
                                }
                            }, {
                                type: 'value',
                                name: data[1].dw,
                                min: 0,
                                // max: (parseInt(Math.max(...LINENUM) / 100) + 1) < 10 ? (parseInt(Math.max(...LINENUM) / 100) + 1) * 10 : (parseInt(Math.max(...LINENUM) / 100) + 1) * 100, // 取最大值为最大刻度
                                position: 'right',
                                axisLine: {
                                    show: false,
                                    lineStyle: {
                                        color: xyTextColor
                                    }
                                },
                                axisTick: {
                                    show: false, //隐藏X轴刻度
                                },
                                splitLine: {
                                    show: false
                                },
                                axisLabel: {
                                    show: true,
                                    color: xyTextColor,
                                    fontSize: xyTextSize,
                                    formatter: '{value}'
                                }
                            }],
                            series: [{
                                name: data[0].name,
                                type: 'line',
                                symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
                                showAllSymbol: true,
                                symbolSize: 0,
                                smooth: false,
                                lineStyle: {
                                    normal: {
                                        width: 2,
                                        color: 'rgba(' + data[0].color + ',1)', // 线条颜色
                                    },
                                    borderColor: 'rgba(0,0,0,.4)',
                                },
                                itemStyle: {
                                    color: 'rgba(25,163,223,1)',
                                    borderColor: '#646ace',
                                    borderWidth: 2
                                },
                                areaStyle: { //区域填充样式
                                    normal: {
                                        //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: 'rgba(' + data[0].color + ',.3)'
                                            },
                                            {
                                                offset: 1,
                                                color: 'rgba(' + data[0].color + ', 0)'
                                            }
                                        ], false),
                                        shadowColor: 'rgba(' + data[0].color + ', 0.5)', //阴影颜色
                                        shadowBlur: 20 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                                    }
                                },
                                yAxisIndex: 0,
                                data: data[0].data
                            }, {
                                name: data[1].name,
                                type: 'line',
                                symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
                                showAllSymbol: true,
                                symbolSize: 0,
                                smooth: false,
                                lineStyle: {
                                    normal: {
                                        width: 2,
                                        color: 'rgba(' + data[1].color + ',1)', // 线条颜色
                                    },
                                    borderColor: 'rgba(0,0,0,.4)',
                                },
                                itemStyle: {
                                    color: 'rgba(' + data[1].color + ',1)',
                                    borderColor: '#646ace',
                                    borderWidth: 2

                                },
                                areaStyle: { //区域填充样式
                                    normal: {
                                        //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: 'rgba(' + data[1].color + ',.3)'
                                            },
                                            {
                                                offset: 1,
                                                color: 'rgba(' + data[1].color + ', 0)'
                                            }
                                        ], false),
                                        shadowColor: 'rgba(' + data[1].color + ', 0.5)', //阴影颜色
                                        shadowBlur: 20 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                                    }
                                },
                                yAxisIndex: 1,
                                data: data[1].data
                            }]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 散点图
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     */
                    getScatterDiagramOption(id, name, data) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }

                        var resData = []
                        data.map((item) => {
                            resData.push({
                                name: item.name,
                                number: item.num,
                                value: item.position,
                                symbolSize: item.size,
                                itemStyle: {
                                    normal: {
                                        color: new echarts.graphic.RadialGradient(0, 1, .5, [
                                            {
                                                offset: 0,
                                                color: item.color1
                                            },
                                            {
                                                offset: 1,
                                                color: item.color,
                                            },
                                        ]),
                                        borderWidth: 0,
                                        borderColor: item.color,
                                    },
                                },
                            });
                        });

                        let option = {
                            grid: {
                                show: false,
                                top: 10,
                                bottom: 10,
                            },
                            xAxis: [
                                {
                                    type: 'value',
                                    show: false,
                                    min: 0,
                                    max: 100,
                                },
                            ],
                            yAxis: [
                                {
                                    min: 0,
                                    show: false,
                                    max: 100,
                                },
                            ],
                            series: [
                                {
                                    type: 'scatter',
                                    symbol: 'circle',
                                    symbolSize: 120,
                                    label: {
                                        normal: {
                                            show: true,
                                            formatter: '{b}', // \n{c}
                                            color: '#fff',
                                            textStyle: {
                                                fontSize: xyTextSize
                                            },
                                        },
                                    },
                                    animationDurationUpdate: 500,
                                    animationEasingUpdate: 500,
                                    animationDelay: function (idx) {
                                        // 越往后的数据延迟越大
                                        return idx * 100;
                                    },
                                    data: resData,
                                },
                            ]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 象形柱线图
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} xData  x轴数据
                     * @param {*} colors  颜色数组
                     * @param {*} legendShow  是否显示图例
                     * @param {*} num  单位切换
                     */
                    getSongBarLineOption: function (id, name, data, xData, colors, legendShow) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!colors) {
                            colors = ['#6ce7df', '#fdd63d', '#ffae02', '#ff7877', '#ff94c2', '#764fce', '#007ed4', '#2297ff', '#35bbff']
                        }
                        if (!legendShow) {
                            legendShow = false
                        }
                        var legendData = []
                        var maxArr = [100, 100, 100, 100, 100, 100, 100]
                        // var BARNUM = data.length > 0 ? data[0].data : []
                        // var LINENUM = data.length > 0 ? data[1].data : []
                        data.map((item, index) => {
                            legendData.push(item.name)
                        })
                        let option = {
                            color: colors,
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'shadow'
                                },
                                // formatter: function (params) {
                                //     return (
                                //         params[0].data.nameCode +
                                //         '<br>' +
                                //         '杆塔数量(基数) :' +
                                //         params[0].value
                                //     )
                                // }
                            },
                            grid: {
                                left: '3%',
                                right: '3%',
                                bottom: '-8%',
                                top: '15%',
                                containLabel: true
                            },
                            legend: [{
                                show: true,
                                data: legendData,
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: xyTextColor
                                }
                            }],
                            xAxis: {
                                data: xData,
                                axisTick: {
                                    show: true
                                },
                                axisLine: {
                                    show: true
                                },
                                axisLabel: {
                                    show: true,
                                    rotate: -45,
                                    interval: 0,
                                    textStyle: {
                                        color: xyTextColor,
                                        padding: [20, 0, 0, 0]
                                    },
                                    formatter: function (val) {
                                        return val.substr(0, 6) + '\n' + val.substr(6, 12)
                                    }
                                }
                            },
                            yAxis: [{
                                name: '碳排放量',
                                nameTextStyle: {
                                    color: xyTextColor,
                                    fontSize: xyTextSize
                                },
                                splitLine: {
                                    show: false
                                },
                                axisTick: {
                                    show: false
                                },
                                // max: (parseInt(Math.max(...BARNUM) / 100) + 1) < 2 ? (parseInt(Math.max(...BARNUM) / 100) + 1) * 2 : ((parseInt(Math.max(...BARNUM) / 100) + 1) < 10 ? (parseInt(Math.max(...BARNUM) / 100) + 1) * 10 : (parseInt(Math.max(...BARNUM) / 100) + 1) * 100),
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: xyTextColor
                                    }
                                },
                                axisLabel: {
                                    show: true,
                                    textStyle: {
                                        color: xyTextColor,
                                        fontSize: xyTextSize
                                    }
                                }
                            }, {
                                name: '碳排放强度',
                                nameTextStyle: {
                                    color: xyTextColor,
                                    fontSize: xyTextSize
                                },
                                splitLine: {
                                    show: false
                                },
                                axisTick: {
                                    show: false
                                },
                                // max: (parseInt(Math.max(...LINENUM) / 100) + 1) < 10 ? (parseInt(Math.max(...LINENUM) / 100) + 1) * 10 : (parseInt(Math.max(...LINENUM) / 100) + 1) * 100,
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: xyTextColor
                                    }
                                },
                                axisLabel: {
                                    show: true,
                                    textStyle: {
                                        color: xyTextColor,
                                        fontSize: xyTextSize
                                    }
                                }
                            }],
                            series: [{
                                    name: data[0].name,
                                    barMinHeight: 10,
                                    type: 'pictorialBar',
                                    barCategoryGap: '60%',
                                    symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
                                    data: data[0].data,
                                    z: 10
                                },
                                {
                                    name: data[1].name,
                                    type: 'line',
                                    showAllSymbol: true,
                                    symbolSize: 0,
                                    smooth: false,
                                    yAxisIndex: 1,
                                    data: data[1].data
                                },
                                {
                                    name: '',
                                    type: 'bar',
                                    barWidth: '20%',
                                    symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
                                    itemStyle: {
                                        normal: {
                                            color: 'rgba(11,47,68,0)'
                                        }
                                    },
                                    data: maxArr,
                                    z: 9
                                }
                            ]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 柱线图
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据 []
                     * @param {*} xAxisData  数据 []
                     * @param {*} colors  颜色数组
                     * @param {*} legendShow  是否显示图例
                     */
                    getBarLineOption: function (id, name, data, xAxisData, colors, legendShow) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!xAxisData) {
                            xAxisData = []
                        }
                        if (!legendShow) {
                            legendShow = false
                        }
                        if (!colors) {
                            colors = ['#6ce7df', '#fdd63d', '#ffae02', '#ff7877', '#ff94c2', '#764fce', '#007ed4', '#2297ff', '#35bbff']
                        }
                        var seriesData = data
                        var legendData = []
                        var BARNUM = data.length > 0 ? data[0].data : []
                        var LINENUM = data.length > 0 ? data[1].data : []
                        var xAxis = xAxisData
                        data.map(item => {
                            legendData.push(item.name)
                        })
                        let option = {
                            color: colors,
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'cross',
                                    crossStyle: {
                                        color: '#999'
                                    }
                                },
                                formatter: function (params) {
                                    var html = '<div>'
                                    params.map((item, i) => {
                                        html += '   <span style="color:#fff">' + params[i].seriesName + '</span> <br/>'
                                        html += params[i].marker
                                        html += '   <span style="color:#fff">' + params[i].name + '</span>'
                                        html += '   <span style="color:#fff">：' + params[i].data + data[i].dw + '</span> <br/>'
                                    })
                                    html += '</div>'

                                    return html
                                }
                            },
                            grid: [
                                {
                                    left: clientWidth > 1025 ? '3%' : '0%',
                                    bottom: '0%',
                                    top: clientWidth > 1025 ? '22%' : '30%',
                                    right: clientWidth > 1025 ? '3%' : '8%',
                                    containLabel: true
                                }
                            ],
                            legend: {
                                show: legendShow,
                                data: legendData,
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: xyTextColor
                                }
                            },
                            xAxis: [
                                {
                                    type: 'category',
                                    axisLine: {
                                        show: true,
                                        lineStyle: {
                                            color: '#999999'
                                        }
                                    },
                                    splitLine: {
                                        show: false
                                    },
                                    data: xAxis,
                                    axisPointer: {
                                        // show: false,
                                        type: 'shadow'
                                    },
                                    axisLabel: {
                                        interval: 0,
                                        rotate: -30,
                                        fontSize: clientWidth > 1025 ? xyTextSize : '9px',
                                        color: xyTextColor,
                                        formatter: function (val) {
                                            return val.substr(0, 6) + '\n' + val.substr(6, 12)
                                        }
                                    }
                                }
                            ],
                            yAxis: [
                                {
                                    type: 'value',
                                    name: data[0].dw,
                                    nameTextStyle: {
                                        color: xyTextColor,
                                        fontSize: xyTextSize,
                                        padding: [0, 0, 0, 0]
                                    },
                                    min: 0,
                                    max: (parseInt(Math.max(...BARNUM) / 100) + 1) * 100, // 取最大值为最大刻度
                                    position: 'left',
                                    axisLine: {
                                        show: true,
                                        lineStyle: {
                                            color: xyTextColor
                                        }
                                    },
                                    splitLine: {
                                        show: false
                                    },
                                    axisLabel: {
                                        color: xyTextColor,
                                        fontSize: xyTextSize,
                                        formatter: '{value}'
                                    }
                                },
                                {
                                    type: 'value',
                                    name: data[1].dw,
                                    nameTextStyle: {
                                        color: xyTextColor,
                                        fontSize: xyTextSize,
                                        padding: [0, 20, 0, 0]
                                    },
                                    min: 0,
                                    max: (parseInt(Math.max(...LINENUM)) + 1), // 取最大值为最大刻度
                                    position: 'right',
                                    axisLine: {
                                        show: true,
                                        lineStyle: {
                                            color: xyTextColor
                                        }
                                    },
                                    splitLine: {
                                        show: false
                                    },
                                    axisLabel: {
                                        color: xyTextColor,
                                        fontSize: xyTextSize,
                                        formatter: '{value}'
                                    }
                                }
                            ],
                            series: seriesData
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 内外双环形图
                     * @param {*} id  id
                     * @param {*} name  series外环名称
                     * @param {*} name1  series内环名称
                     * @param {*} data  数据
                     * @param {*} colors  颜色数组
                     * @param {*} radius1  外环环形半径
                     * @param {*} center1  外环中心点位置
                     * @param {*} radius2  内环环形半径
                     * @param {*} center2  内环中心点位置
                     * @param {*} legendShow  是否显示图例
                     */
                    getBicyclicGraphPieOption: function (id, name, name1, data, colors, radius1, radius2, center1, center2, legendShow) {
                        if (!name) {
                            name = ''
                        }
                        if (!radius1) {
                            radius1 = ['40%', '50%']
                        }
                        if (!radius2) {
                            radius1 = ['40%', '50%']
                        }
                        if (!center1) {
                            center1 = ['50%', '75%']
                        }
                        if (!center2) {
                            center2 = ['25%', '50%']
                        }
                        if (!data) {
                            data = {}
                        }
                        if (!legendShow) {
                            legendShow = false
                        }
                        if (!colors) {
                            colors = ['#6ce7df', '#fdd63d', '#ffae02', '#ff7877', '#ff94c2', '#764fce', '#007ed4', '#2297ff', '#35bbff']
                        }
                        // // 获取图例数据
                        var arrName = JSON.stringify(data) !== '{}' ? data.label : []
                        // 外环
                        var outerData = JSON.stringify(data) !== '{}' !== 0 ? data.outer : []
                        // 内环
                        var innerData = JSON.stringify(data) !== '{}' !== 0 ? data.inner : []

                        arrName.map((item, index) => {
                            outerData[index].name = item
                            innerData[index].name = item
                            outerData[index].value = outerData[index].value / 10000 // 亿元
                            // innerData[index].value = outerData[index].value / 10000 // 万吨
                        })
                        var option = {
                            tooltip: {
                                trigger: 'item',
                                formatter: function (params, i) {
                                    return `<span style='color:#fff'>${params.seriesName} </span> <br/>
                                        ${params.marker}
                                        <span style="color:#fff">${params.data.name ? params.data.name : ''}：</span>
                                        <span style="color:#fff">${params.data.value.toFixed(2)}${params.seriesName === '工业增加值占比' ? '亿元' : '万吨CO₂'}</span>`
                                }
                            },
                            color: colors,
                            legend: {
                                show: legendShow,
                                top: 'center',
                                left: clientWidth > 1025 ? '70%' : '60%',
                                data: arrName,
                                itemWidth: clientWidth > 1025 ? 20 : 10,
                                // itemHeight: 20,
                                // padding: [0, 5],
                                itemGap: clientWidth > 1025 ? 13 : 0,
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: xyTextColor
                                },
                                formatter: function (name) {
                                    return name.substr(0, 6) + '\n' + name.substr(6, 12)
                                }
                            },
                            series: [
                                {
                                    name: name,
                                    type: 'pie',
                                    radius: radius1,
                                    center: center1,
                                    startAngle: '240',
                                    data: outerData,
                                    labelLine: {
                                        normal: {
                                            length: 20,
                                            length2: 140,
                                            lineStyle: {
                                                color: '#e6e6e6'
                                            }
                                        }
                                    },
                                    itemStyle: { // 此配置
                                        normal: {
                                            borderWidth: 2,
                                            borderColor: '#fff'
                                        },
                                        emphasis: {
                                            borderWidth: 0,
                                            shadowBlur: 10,
                                            shadowOffsetX: 0,
                                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                                        }
                                    },
                                    label: {
                                        normal: {
                                            position: 'inner',
                                            formatter: '{d}%',
                                            // formatter: params => {
                                            //     // return (
                                            //     //     params.value + '%'
                                            //     // )
                                            // },
                                            fontSize: xyTextSize,
                                            color: xyTextColor
                                            // padding: [0, -130, 25, -130],
                                        }
                                    }
                                },
                                {
                                    name: name1,
                                    type: 'pie',
                                    radius: radius2,
                                    center: center2,
                                    itemStyle: { // 此配置
                                        normal: {
                                            borderWidth: 2,
                                            borderColor: '#fff'
                                        },
                                        emphasis: {
                                            borderWidth: 0,
                                            shadowBlur: 10,
                                            shadowOffsetX: 0,
                                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                                        }
                                    },
                                    label: {
                                        normal: {
                                            position: 'inner',
                                            formatter: '{d}%',
                                            // formatter: params => {
                                            //     return (
                                            //         params.value + '%'
                                            //     )
                                            // },
                                            fontSize: xyTextSize,
                                            color: xyTextColor
                                        }
                                    },
                                    labelLine: {
                                        normal: {
                                            show: false
                                        }
                                    },
                                    startAngle: '230',
                                    data: innerData
                                }
                            ]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 环形图
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} colors  颜色数组
                     * @param {*} radius  环形半径
                     * @param {*} center  中心点位置
                     * @param {*} legendShow  是否显示图例
                     */
                    getPieOption: function (id, name, data, colors, radius, center, legendShow, legendStyle, titlebarName, iftxtcolor) {
                        if (!name) {
                            name = ''
                        }
                        if (!radius) {
                            radius = ['40%', '50%']
                        }
                        if (!center) {
                            center = ['50%', '75%']
                        }
                        if (!data) {
                            data = []
                        }
                        if (!legendShow) {
                            legendShow = false
                        }
                        if (!iftxtcolor) {
                            iftxtcolor = false
                        }
                        if (!colors) {
                            colors = ['#6ce7df', '#fdd63d', '#ffae02', '#ff7877', '#ff94c2', '#764fce', '#007ed4', '#2297ff', '#35bbff']
                        }
                        var option = {
                            tooltip: {
                                trigger: 'item',
                                formatter: function (params) {
                                    return `<div>
                                        <span style='color:#fff'>${titlebarName} </span> <br/>
                                        ${params.marker}<span style='color:#fff'>${params.name}类企业数：${params.value} 家</span>
                                    </div>`
                                }
                            },
                            color: colors,
                            legend: {
                                show: legendShow,
                                top: '1',
                                right: '1',
                                orient: 'vertical',
                                icon: legendStyle,
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: iftxtcolor ? darkColor : xyTextColor
                                }
                            },
                            series: [
                                {
                                    name: '',
                                    type: 'pie',
                                    radius: radius,
                                    center: center,
                                    avoidLabelOverlap: false,
                                    label: {
                                        show: false,
                                        position: 'center'
                                    },
                                    emphasis: {
                                        label: {
                                            show: true,
                                            fontSize: xyTextSize,
                                            color: iftxtcolor ? darkColor : xyTextColor,
                                            fontWeight: 'bold'
                                        }
                                    },
                                    labelLine: {
                                        show: false
                                    },
                                    data: data
                                }
                            ]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 多彩象形柱图(可渐变)
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} colors  颜色数组
                     * @param {*} legendShow  是否显示图例
                     * @param {*} num  单位切换
                     */
                    getSongBarOption: function (id, name, data, colors, legendShow, num, iftxtcolor, type) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!colors) {
                            colors = ['#6ce7df', '#fdd63d', '#ffae02', '#ff7877', '#ff94c2', '#764fce', '#007ed4', '#2297ff', '#35bbff']
                        }
                        if (!legendShow) {
                            legendShow = false
                        }
                        if (!iftxtcolor) {
                            iftxtcolor = false
                        }
                        var optionData = {
                            type: 'pictorialBar',
                            name: '提示框值',
                            data: [],
                            stack: 'a',
                            symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z'
                        }
                        var seriesList = []
                        var xAxis = []
                        colors.map((_item, _index) => {
                            data.map((item, index) => {
                                if (_index === index) {
                                    let list = {
                                        name: '',
                                        value: item.value.toFixed(2),
                                        label: {
                                            show: true,
                                            position: 'top',
                                            formatter: function (params) {
                                                // var index = params.dataIndex
                                                var str = '{a|' + params.value + '}'
                                                return str
                                            },
                                            rich: {
                                                a: {
                                                    fontSize: xyTextSize,
                                                    color: iftxtcolor ? darkColor : xyTextColor,
                                                    align: 'center',
                                                    height: 40
                                                }
                                            }
                                        },
                                        itemStyle: {
                                            normal: {
                                                color: {
                                                    type: 'linear',
                                                    x: 0,
                                                    y: 0,
                                                    x2: 0,
                                                    y2: 1,
                                                    colorStops: [{
                                                        offset: 0,
                                                        color: _item.colorEnd
                                                    },
                                                    {
                                                        offset: 1,
                                                        color: _item.colorStart
                                                    }
                                                    ],
                                                    global: false
                                                }
                                            }
                                        }
                                    }
                                    optionData.data.push(list)
                                    let nameData = {
                                        name: item.name,
                                        stack: 'a',
                                        type: 'bar'
                                    }
                                    xAxis.push(item.name)
                                    seriesList.push(nameData)
                                }
                            })
                        })
                        seriesList.push(optionData)
                        let option = {
                            grid: {
                                left: clientWidth < 1025 ? '3%' : '3%',
                                top: clientWidth < 1025 ? '20%' : '20%',
                                right: clientWidth < 1025 ? '3%' : '3%',
                                bottom: '0%',
                                containLabel: true
                            },
                            legend: {
                                show: legendShow,
                                data: xAxis,
                                top: '92%',
                                icon: 'circle',
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: iftxtcolor ? darkColor : xyTextColor
                                }
                            },
                            tooltip: {
                                position: 'top',
                                // formatter: num === 0 ? '碳排强度：<br/>{b}: {c}吨/万元' : (num === 1 ? '碳排放量：<br/>{b}: {c}万吨CO₂' : '能耗强度：<br/>{b}: {c}吨/万元')
                                formatter: num === 0 ? '{b}<br/>能耗总量：{c}万吨标煤 ' : (num === 1 ? '{b}<br/>能耗强度：{c}吨标煤/万元' : (num === 2 ? '{b}<br/>碳排放量：{c}万吨CO₂' : (num === 3 ? '{b}<br/>碳排强度：{c}吨CO₂/万元' : '')))
                            },
                            xAxis: {
                                type: 'category',
                                data: xAxis,
                                axisLabel: {
                                    show: true,
                                    color: iftxtcolor ? darkColor : xyTextColor,
                                    fontSize: xyTextSize,
                                    rotate: 40
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: iftxtcolor ? darksplitLine : xyTextColor
                                    }
                                },
                                splitLine: {
                                    show: false
                                }
                            },
                            yAxis: {
                                type: 'value',
                                name: num === 0 ? '万吨标煤' : (num === 1 ? '吨标煤/万元' : (num === 2 ? '万吨CO₂' : (num === 3 ? '吨CO₂/万元' : ''))),
                                nameTextStyle: {
                                    color: iftxtcolor ? darkColor : xyTextColor,
                                    fontSize: xyTextSize,
                                    padding: type === 'quYu' ? [0, 0, 20, 15] : [0, 0, 0, 15]
                                },
                                axisLabel: {
                                    show: true,
                                    color: iftxtcolor ? darkColor : xyTextColor,
                                    fontSize: xyTextSize
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: iftxtcolor ? darksplitLine : xyTextColor
                                    }
                                },
                                splitLine: {
                                    show: true
                                }
                            },
                            series: seriesList
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 单柱图(单轴)
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} xData  x轴数据
                     * @param {*} colors  颜色数组
                     * @param {*} legendShow  是否显示图例
                     * @param {*} isProvince  是否显示右侧轴线数据
                     */
                    getSongBarOneOption: function (id, name, data, xData, colors, legendShow, iftxtcolor) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!colors) {
                            colors = ['#6ce7df', '#fdd63d', '#ffae02', '#ff7877', '#ff94c2', '#764fce', '#007ed4', '#2297ff', '#35bbff']
                        }
                        if (!legendShow) {
                            legendShow = false
                        }
                        if (!iftxtcolor) {
                            iftxtcolor = false
                        }
                        var legendData = []
                        data.map((item, index) => {
                            legendData.push(item.name)
                        })

                        let option = {
                            color: colors,
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'shadow'
                                },
                                formatter: (params) => {
                                    var html = '<div>'
                                    params.map((item, i) => {
                                        html += '   <span style="color:#fff">' + params[i].name + '</span> <br/>'
                                        html += params[i].marker
                                        html += '   <span style="color:#fff">' + params[i].seriesName + '：</span>'
                                        html += '   <span style="color:#fff">' + params[i].data + data[i].unit + '</span> <br/>'
                                    })
                                    html += '</div>'

                                    return html
                                }
                            },
                            grid: {
                                left: '3%',
                                right: '3%',
                                bottom: '3%',
                                top: (clientWidth < 1200) ? '22%' : (clientWidth > 1200 && clientWidth < 1500) ? '15%' : '12%',
                                containLabel: true
                            },
                            legend: {
                                show: true,
                                data: legendData,
                                right: '3%',
                                top: '0%',
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: iftxtcolor ? darkColor : xyTextColor
                                }
                            },
                            xAxis: {
                                data: xData,
                                axisTick: {
                                    show: true
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: iftxtcolor ? darksplitLine : xyTextColor
                                    }
                                },
                                axisLabel: {
                                    show: true,
                                    rotate: 45,
                                    interval: 0,
                                    textStyle: {
                                        color: iftxtcolor ? darkColor : xyTextColor,
                                        fontSize: xyTextSize
                                    },
                                    margin: 10,
                                    formatter: function (val) {
                                        return val
                                    }
                                }
                            },
                            yAxis: [{
                                name: '单位：' + data[0].unit,
                                // name: data[0].name + ': ' + data[0].unit,
                                nameTextStyle: {
                                    color: iftxtcolor ? darkColor : xyTextColor,
                                    fontSize: xyTextSize,
                                    padding: [0, 0, 0, 20]
                                },
                                position: 'left',
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        type: 'dashed',
                                        color: iftxtcolor ? darksplitLine : '#DDD'
                                    }
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: iftxtcolor ? darksplitLine : xyTextColor
                                    }
                                },
                                axisLabel: {
                                    show: true,
                                    textStyle: {
                                        color: iftxtcolor ? darkColor : xyTextColor,
                                        fontSize: xyTextSize
                                    }
                                }
                            }],
                            series: [{
                                name: data[0].name,
                                yAxisIndex: 0,
                                type: 'bar',
                                barWidth: 20,
                                data: data[0].data
                            }]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 双柱图(双轴)
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} xData  x轴数据
                     * @param {*} colors  颜色数组
                     * @param {*} legendShow  是否显示图例
                     * @param {*} isProvince  是否显示右侧轴线数据
                     */
                    getSongBarTwoOption: function (id, name, data, xData, colors, legendShow, iftxtcolor) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!colors) {
                            colors = ['#6ce7df', '#fdd63d', '#ffae02', '#ff7877', '#ff94c2', '#764fce', '#007ed4', '#2297ff', '#35bbff']
                        }
                        if (!legendShow) {
                            legendShow = false
                        }
                        if (!iftxtcolor) {
                            iftxtcolor = false
                        }
                        var legendData = []
                        var seriesData = []
                        data.map((item, index) => {
                            var str = {
                                name: item.name,
                                yAxisIndex: index,
                                type: 'bar',
                                data: item.data
                            }
                            seriesData.push(str)
                            legendData.push(item.name)
                        })
                        let option = {
                            color: colors,
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'shadow'
                                },
                                formatter: (params) => {
                                    var html = '<div>'
                                    html += '   <span style="color:#fff">' + params[0].name + '</span> <br/>'
                                    params.map((item, i) => {
                                        html += params[i].marker
                                        html += '   <span style="color:#fff">' + params[i].seriesName + '：</span>'
                                        html += '   <span style="color:#fff">' + params[i].data + data[i].unit + '</span> <br/>'
                                    })
                                    html += '</div>'

                                    return html
                                }
                            },
                            grid: {
                                left: '3%',
                                right: '3%',
                                bottom: '10%',
                                top: (clientWidth < 1200) ? '30%' : (clientWidth > 1200 && clientWidth < 1500) ? '20%' : '15%', // clientWidth > 1025 ? '15%' :
                                containLabel: true
                            },
                            legend: {
                                show: true,
                                data: legendData,
                                top: 'bottom',
                                // left: clientWidth > 1025 ? '70%' : '60%',
                                itemWidth: 20,
                                // itemHeight: 20,
                                // padding: [0, 5],
                                itemGap: clientWidth > 1025 ? 13 : 0,
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: iftxtcolor ? darkColor : xyTextColor
                                },
                                formatter: function (name) {
                                    return name
                                }
                            },
                            xAxis: {
                                data: xData,
                                axisTick: {
                                    show: true
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: iftxtcolor ? darksplitLine : xyTextColor
                                    }
                                },
                                axisLabel: {
                                    show: true,
                                    rotate: 45,
                                    interval: 0,
                                    textStyle: {
                                        fontSize: xyTextSize,
                                        color: iftxtcolor ? darkColor : xyTextColor
                                    },
                                    margin: 8,
                                    formatter: function (val) {
                                        return val
                                    }
                                },
                                axisPointer: {
                                    show: false,
                                    type: 'shadow'
                                }
                            },
                            yAxis: [{
                                name: clientWidth > 1025 ? (data[0].name + '\n' + data[0].unit) : (data[0].name + '\n' + data[0].unit),
                                nameTextStyle: {
                                    color: iftxtcolor ? darkColor : xyTextColor,
                                    fontSize: xyTextSize,
                                    padding: clientWidth > 1025 ? [0, 0, 0, 50] : [0, 0, 0, 0]
                                },
                                position: 'left',
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        type: 'dashed',
                                        color: iftxtcolor ? darksplitLine : '#DDD'
                                    }
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: iftxtcolor ? darksplitLine : xyTextColor
                                    }
                                },
                                axisLabel: {
                                    show: true,
                                    textStyle: {
                                        color: iftxtcolor ? darkColor : xyTextColor,
                                        fontSize: xyTextSize
                                    }
                                }
                            }, {
                                name: clientWidth > 1025 ? (data[1].name + '\n' + data[1].unit) : (data[1].name + '\n' + data[1].unit),
                                nameTextStyle: {
                                    color: iftxtcolor ? darkColor : xyTextColor,
                                    fontSize: xyTextSize,
                                    padding: clientWidth > 1025 ? [0, 70, 0, 0] : [0, 0, 0, 0]
                                },
                                position: 'right',
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        type: 'dashed',
                                        color: iftxtcolor ? darksplitLine : '#DDD'
                                    }
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: iftxtcolor ? darksplitLine : xyTextColor
                                    }
                                },
                                axisLabel: {
                                    show: true,
                                    textStyle: {
                                        color: iftxtcolor ? darkColor : xyTextColor,
                                        fontSize: xyTextSize
                                    }
                                }
                            }],
                            series: seriesData
                            // series: [{
                            //         name: data[0].name,
                            //         yAxisIndex: 0,
                            //         type: 'bar',
                            //         data: data[0].data
                            //     },
                            //     {
                            //         name: data[1].name,
                            //         type: 'bar',
                            //         yAxisIndex: 1,
                            //         data: data[1].data
                            //     }
                            // ]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 曲线图
                     * @param {*} id  id
                     * @param {*} data  数据
                     * @param {*} colors  颜色数组
                     */
                    getDiagramLineOption: function (id, data, year, colors) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!colors) {
                            colors = ['#5b9bd5', '#ed7d31', '#a5a5a5', '#ffc003', '#4472c4', '#70ad47']
                        }
                        var xAxisName = []
                        data.map((item,index) => {
                            xAxisName.push(item.name)
                        })

                        let option = {
                            color: colors,
                            tooltip: {
                                trigger: 'axis',
                                // formatter: function (params, i) {
                                //     var html = '<div>'
                                //     html += '   <span style="color:#fff">' + params[0].name + '</span> <br/>'
                                //     params.map((item, i) => {
                                //         html += params[i].marker
                                //         html += '   <span style="color:#fff">' + params[i].seriesName ? params[i].seriesName : '' + '</span>'
                                //         html += '   <span style="color:#fff">：' + params[i].data + ' 万吨CO₂</span> <br/>'
                                //     })
                                //     html += '</div>'

                                //     return html
                                // }
                            },
                            legend: {
                                show: true,
                                top: '0%',
                                data: xAxisName,
                                itemWidth: 15,
                                // type: 'plain',
                                itemGap: 5,
                                itemHeight: 6,
                                textStyle: {
                                    fontSize: 12,
                                    color: '#666666'
                                }
                            },
                            grid: {
                                left: '3%',
                                right: '5%',
                                top: '15%',
                                bottom: '6%',
                                containLabel: true
                            },
                            xAxis: [{
                                type: 'category',
                                axisLine: {
                                    lineStyle: {
                                        color: '#ccc'
                                    }
                                },
                                splitLine: {
                                    show: false,
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLabel: {
                                    show: true,
                                    // rotate: 45,
                                    interval: 0,
                                    textStyle: {
                                        color: '#666666',
                                        fontSize: 12
                                    },
                                    margin: 10,
                                    formatter: function (val) {
                                        return val
                                    }
                                },
                                // boundaryGap: false,
                                data: year
                            }],
                            yAxis: [
                                {
                                    name: '用电量(kWh)',
                                    nameTextStyle: {
                                        color: '#666666',
                                        fontSize: 12,
                                        padding: [0, 0, 0, 20]
                                    },
                                    position: 'left',
                                    min: 0,
                                    axisLine: {
                                        lineStyle: {
                                            color: xyTextColor
                                        }
                                    },
                                    axisLabel: {
                                        show: true,
                                        color: '#666666',
                                        fontSize: 12,
                                        // showMinLabel: false, // 不显示最小刻度线值
                                        // showMaxLabel: false // 不显示最大刻度线值
                                    },
                                    splitLine: {
                                        show: true,
                                        lineStyle: {
                                            color: '#ccc'
                                        }
                                    },
                                    axisTick: {
                                        show: false
                                    },
                                    // type: 'value',
                                    scale: true, // 自适应
                                    // interval: 20 // 每次增加几个
                                },
                                {
                                    name: '节约电量(kWh)',
                                    nameTextStyle: {
                                        color: '#666666',
                                        fontSize: 12,
                                        padding: [0, 20, 0, 0]
                                    },
                                    position: 'right',
                                    min: 0,
                                    axisLine: {
                                        lineStyle: {
                                            color: xyTextColor
                                        }
                                    },
                                    axisLabel: {
                                        show: true,
                                        color: '#666666',
                                        fontSize: 12,
                                        // showMinLabel: false, // 不显示最小刻度线值
                                        // showMaxLabel: false // 不显示最大刻度线值
                                    },
                                    splitLine: {
                                        show: false,
                                        lineStyle: {
                                            color: '#ccc'
                                        }
                                    },
                                    axisTick: {
                                        show: false
                                    },
                                    // type: 'value',
                                    scale: true, // 自适应
                                    // interval: 0 // 每次增加几个
                                }
                            ],
                            series: data
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 立体柱图(长方形)
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} xData  x轴数据
                     * @param {*} colors  颜色数组
                     * @param {*} legendShow  是否显示图例
                     */
                    getBarLiTiOption1(id, name, data, xData, colors, legendShow, iftxtcolor) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!colors) {
                            colors = ['#5b9bd5', '#ed7d31', '#a5a5a5', '#ffc003', '#4472c4', '#70ad47']
                        }
                        if (!legendShow) {
                            legendShow = false
                        }
                        if (!iftxtcolor) {
                            iftxtcolor = false
                        }
                        // 绘制左侧面
                        const CubeLeft = echarts.graphic.extendShape({
                            shape: {
                                x: 0,
                                y: 0
                            },
                            buildPath: function (ctx, shape) {
                                // 会canvas的应该都能看得懂，shape是从custom传入的
                                const xAxisPoint = shape.xAxisPoint
                                const c0 = [shape.x - 0, shape.y]
                                const c1 = [shape.x - 15, shape.y - 6]
                                const c2 = [xAxisPoint[0] - 15, xAxisPoint[1] - 10]
                                const c3 = [xAxisPoint[0] + 0, xAxisPoint[1]]
                                ctx.moveTo(c0[0], c0[1]).lineTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).closePath()
                            }
                        })
                        // 绘制右侧面
                        const CubeRight = echarts.graphic.extendShape({
                            shape: {
                                x: 0,
                                y: 0
                            },
                            buildPath: function (ctx, shape) {
                                const xAxisPoint = shape.xAxisPoint
                                const c1 = [shape.x + 0, shape.y]
                                const c2 = [xAxisPoint[0] + 0, xAxisPoint[1]]
                                const c3 = [xAxisPoint[0] + 14, xAxisPoint[1] - 0]
                                const c4 = [shape.x + 14, shape.y - 3]
                                ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1]).closePath()
                            }
                        })
                        // 绘制顶面
                        const CubeTop = echarts.graphic.extendShape({
                            shape: {
                                x: 0,
                                y: 0
                            },
                            buildPath: function (ctx, shape) {
                                const c1 = [shape.x + 0, shape.y]
                                const c2 = [shape.x + 15, shape.y - 3] // 右点
                                const c3 = [shape.x - 5, shape.y - 10]
                                const c4 = [shape.x - 15, shape.y - 6]
                                ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1]).closePath()
                            }
                        })
                        // 注册三个面图形
                        echarts.graphic.registerShape('CubeLeft', CubeLeft)
                        echarts.graphic.registerShape('CubeRight', CubeRight)
                        echarts.graphic.registerShape('CubeTop', CubeTop)

                        var lengthData = []
                        data.map(item => {
                            lengthData.push(item.name)
                        })

                        let option = {
                            tooltip: {
                                trigger: 'axis',
                                formatter: function (params, ticket, callback) {
                                    const item = params[1]
                                    return item.name + ':\n' + data[0].name.split(':')[0] + ': ' + item.value + data[0].unit
                                }
                            },
                            color: ['#90bffd', '#f69045'],
                            legend: {
                                show: false,
                                right: '1%',
                                data: [{
                                    name: '碳排放量',
                                    icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjU5Njc1RTBCREFFMDExRUE4NEVCQkRGRTI5QkY5MDI3IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjU5Njc1RTBDREFFMDExRUE4NEVCQkRGRTI5QkY5MDI3Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NTk2NzVFMDlEQUUwMTFFQTg0RUJCREZFMjlCRjkwMjciIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NTk2NzVFMEFEQUUwMTFFQTg0RUJCREZFMjlCRjkwMjciLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7F0nHBAAAA6klEQVR42mJk/vqfAQmIAHEREPsAsRoQszNgBz+B+AYQbwLiSX+4GN7AJBjZPsENDAbiuUDMz0Aa+ATEST95GdaCDeR8/x9m2GoQn4E8ADIk9JsAw1pGvlf/RYGcO0DMx0AZALlUlYX1N0MuFQxjgJpRADLQj4F6wIeF7ReDBhUNVAcZSE3wC+RlUHrSp5KB90Au3ERFA7cymhz5LwZk3KZmsnkFSulUSNhJxxwYXoEMBAFQtgkD4nlAzEuiYZ+BOPGgKyTrsTD/hUusAeID0MLBF5QEgJgVhyFfgfgWKMyAeOI+D0ThABBgAAM2PO5tXGk1AAAAAElFTkSuQmCC'
                                }],
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: iftxtcolor ? darkColor : xyTextColor
                                }
                            },
                            grid: {
                                left: '1%',
                                right: '1%',
                                top: '18%',
                                bottom: '10%',
                                containLabel: true
                            },
                            xAxis: {
                                type: 'category',
                                data: xData,
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: iftxtcolor ? darksplitLine : xyTextColor
                                    }
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLabel: {
                                    fontSize: xyTextSize,
                                    color: iftxtcolor ? darkColor : xyTextColor,
                                    rotate: 45,
                                    interval: 0,
                                    margin: 20,
                                    formatter: function (val) {
                                        return val
                                    }
                                }
                            },
                            yAxis: [{
                                type: 'value',
                                name: data[0].name + ': ' + data[0].unit,
                                nameTextStyle: {
                                    color: iftxtcolor ? darkColor : xyTextColor,
                                    fontSize: xyTextSize,
                                    padding: [0, 0, 0, 90]
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: iftxtcolor ? darksplitLine : xyTextColor
                                    }
                                },
                                min: 0,
                                splitLine: {
                                    show: false,
                                    lineStyle: {
                                        type: 'dashed',
                                        color: darksplitLine
                                    }
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLabel: {
                                    fontSize: xyTextSize,
                                    color: iftxtcolor ? darkColor : xyTextColor
                                },
                                boundaryGap: ['20%', '20%']
                            }],
                            series: [{
                                type: 'custom',
                                renderItem: (params, api) => {
                                    const location = api.coord([api.value(0), api.value(1)])
                                    return {
                                        type: 'group',
                                        children: [{
                                            type: 'CubeLeft',
                                            shape: {
                                                api,
                                                xValue: api.value(0),
                                                yValue: api.value(1),
                                                x: location[0],
                                                y: location[1],
                                                xAxisPoint: api.coord([api.value(0), 0])
                                            },
                                            style: {
                                                fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                    offset: 0,
                                                    color: 'rgba(' + data[0].color + ',0.9)'
                                                    // color: 'rgba(27,135,245,0.9)'
                                                },
                                                {
                                                    offset: 1,
                                                    color: 'rgba(' + data[0].color + ',0.6)'
                                                    // color: 'rgba(52,183,250,0.7)'
                                                }
                                                ])
                                            }
                                        }, {
                                            type: 'CubeRight',
                                            shape: {
                                                api,
                                                xValue: api.value(0),
                                                yValue: api.value(1),
                                                x: location[0],
                                                y: location[1],
                                                xAxisPoint: api.coord([api.value(0), 0])
                                            },
                                            style: {
                                                fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                    offset: 0,
                                                    color: 'rgba(' + data[0].color + ',1)'
                                                },
                                                {
                                                    offset: 1,
                                                    color: 'rgba(' + data[0].color + ',0.7)'
                                                }
                                                ])
                                            }
                                        }, {
                                            type: 'CubeTop',
                                            shape: {
                                                api,
                                                xValue: api.value(0),
                                                yValue: api.value(1),
                                                x: location[0],
                                                y: location[1],
                                                xAxisPoint: api.coord([api.value(0), 0])
                                            },
                                            style: {
                                                fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                    offset: 0,
                                                    color: 'rgba(' + data[0].color + ',0.8)'
                                                },
                                                {
                                                    offset: 1,
                                                    color: 'rgba(' + data[0].color + ',0.8)'
                                                }
                                                ])
                                            }
                                        }]
                                    }
                                },
                                data: data[0].data
                            }, {
                                type: 'bar',
                                name: data[0].name,
                                barWidth: 25,
                                label: {
                                    normal: {
                                        show: false
                                    }
                                },
                                itemStyle: {
                                    color: 'transparent'
                                },
                                data: data[0].data
                            }]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 立体柱线图(长方形)
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} xData  x轴数据
                     * @param {*} colors  颜色数组
                     * @param {*} legendShow  是否显示图例
                     */
                    getBarLiTiOption(id, name, data, xData, colors, legendShow) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!colors) {
                            colors = ['#5b9bd5', '#ed7d31', '#a5a5a5', '#ffc003', '#4472c4', '#70ad47']
                        }
                        if (!legendShow) {
                            legendShow = false
                        }
                        // 绘制左侧面
                        const CubeLeft = echarts.graphic.extendShape({
                            shape: {
                                x: 0,
                                y: 0
                            },
                            buildPath: function (ctx, shape) {
                                // 会canvas的应该都能看得懂，shape是从custom传入的
                                const xAxisPoint = shape.xAxisPoint
                                const c0 = [shape.x - 0, shape.y]
                                const c1 = [shape.x - 15, shape.y - 6]
                                const c2 = [xAxisPoint[0] - 15, xAxisPoint[1] - 10]
                                const c3 = [xAxisPoint[0] + 0, xAxisPoint[1]]
                                ctx.moveTo(c0[0], c0[1]).lineTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).closePath()
                            }
                        })
                        // 绘制右侧面
                        const CubeRight = echarts.graphic.extendShape({
                            shape: {
                                x: 0,
                                y: 0
                            },
                            buildPath: function (ctx, shape) {
                                const xAxisPoint = shape.xAxisPoint
                                const c1 = [shape.x + 0, shape.y]
                                const c2 = [xAxisPoint[0] + 0, xAxisPoint[1]]
                                const c3 = [xAxisPoint[0] + 14, xAxisPoint[1] - 0]
                                const c4 = [shape.x + 14, shape.y - 3]
                                ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1]).closePath()
                            }
                        })
                        // 绘制顶面
                        const CubeTop = echarts.graphic.extendShape({
                            shape: {
                                x: 0,
                                y: 0
                            },
                            buildPath: function (ctx, shape) {
                                const c1 = [shape.x + 0, shape.y]
                                const c2 = [shape.x + 15, shape.y - 3] // 右点
                                const c3 = [shape.x - 5, shape.y - 10]
                                const c4 = [shape.x - 15, shape.y - 6]
                                ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1]).closePath()
                            }
                        })
                        // 注册三个面图形
                        echarts.graphic.registerShape('CubeLeft', CubeLeft)
                        echarts.graphic.registerShape('CubeRight', CubeRight)
                        echarts.graphic.registerShape('CubeTop', CubeTop)

                        var lengthData = []
                        data.map(item => {
                            lengthData.push(item.name)
                        })

                        var BARNUM = data.length > 0 ? data[0].data : []
                        var LINENUM = data.length > 0 ? data[1].data : []
                        let option = {
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'shadow'
                                },
                                formatter: function (params, ticket, callback) {
                                    const item = params[1]
                                    return item.name + ' : ' + item.value
                                }
                            },
                            color: ['#90bffd', '#f69045'],
                            legend: {
                                show: legendShow,
                                data: [
                                    {
                                        name: data[0].name,
                                        icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjU5Njc1RTBCREFFMDExRUE4NEVCQkRGRTI5QkY5MDI3IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjU5Njc1RTBDREFFMDExRUE4NEVCQkRGRTI5QkY5MDI3Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NTk2NzVFMDlEQUUwMTFFQTg0RUJCREZFMjlCRjkwMjciIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NTk2NzVFMEFEQUUwMTFFQTg0RUJCREZFMjlCRjkwMjciLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7F0nHBAAAA6klEQVR42mJk/vqfAQmIAHEREPsAsRoQszNgBz+B+AYQbwLiSX+4GN7AJBjZPsENDAbiuUDMz0Aa+ATEST95GdaCDeR8/x9m2GoQn4E8ADIk9JsAw1pGvlf/RYGcO0DMx0AZALlUlYX1N0MuFQxjgJpRADLQj4F6wIeF7ReDBhUNVAcZSE3wC+RlUHrSp5KB90Au3ERFA7cymhz5LwZk3KZmsnkFSulUSNhJxxwYXoEMBAFQtgkD4nlAzEuiYZ+BOPGgKyTrsTD/hUusAeID0MLBF5QEgJgVhyFfgfgWKMyAeOI+D0ThABBgAAM2PO5tXGk1AAAAAElFTkSuQmCC'
                                    },
                                    {
                                        name: data[1].name,
                                        icon: ''
                                    }
                                ],
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: xyTextColor
                                }
                            },
                            grid: {
                                left: '1%',
                                right: '1%',
                                top: '5%',
                                bottom: '10%',
                                containLabel: true
                            },
                            xAxis: {
                                type: 'category',
                                data: xData,
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: xyTextColor
                                    }
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLabel: {
                                    fontSize: xyTextSize,
                                    color: xyTextColor,
                                    margin: 20
                                }
                            },
                            yAxis: [{
                                type: 'value',
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: xyTextColor
                                    }
                                },
                                min: 0,
                                max: (parseInt(Math.max(...BARNUM) / 100) + 1) * 100,
                                splitLine: {
                                    show: false
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLabel: {
                                    fontSize: xyTextSize
                                },
                                boundaryGap: ['20%', '20%']
                            }, {
                                type: 'value',
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: xyTextColor
                                    }
                                },
                                min: 0,
                                max: (parseInt(Math.max(...LINENUM) / 100) + 1) * 10,
                                position: 'right',
                                splitLine: {
                                    show: false
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLabel: {
                                    fontSize: xyTextSize
                                },
                                boundaryGap: ['20%', '20%']
                            }],
                            series: [{
                                type: 'custom',
                                renderItem: (params, api) => {
                                    const location = api.coord([api.value(0), api.value(1)])
                                    return {
                                        type: 'group',
                                        children: [{
                                            type: 'CubeLeft',
                                            shape: {
                                                api,
                                                xValue: api.value(0),
                                                yValue: api.value(1),
                                                x: location[0],
                                                y: location[1],
                                                xAxisPoint: api.coord([api.value(0), 0])
                                            },
                                            style: {
                                                fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                    offset: 0,
                                                    color: 'rgba(48,165,248,0.9)'
                                                },
                                                {
                                                    offset: 0.3,
                                                    color: 'rgba(48,165,248,0.9)'
                                                },
                                                {
                                                    offset: 1,
                                                    color: 'rgba(9,239,255,0.6)'
                                                }
                                                ])
                                            }
                                        }, {
                                            type: 'CubeRight',
                                            shape: {
                                                api,
                                                xValue: api.value(0),
                                                yValue: api.value(1),
                                                x: location[0],
                                                y: location[1],
                                                xAxisPoint: api.coord([api.value(0), 0])
                                            },
                                            style: {
                                                fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                    offset: 0,
                                                    color: 'rgba(48,165,248,0.9)'
                                                },
                                                {
                                                    offset: 0.3,
                                                    color: 'rgba(48,165,248,0.9)'
                                                },
                                                {
                                                    offset: 1,
                                                    color: 'rgba(9,239,255,0.9)'
                                                }
                                                ])
                                            }
                                        }, {
                                            type: 'CubeTop',
                                            shape: {
                                                api,
                                                xValue: api.value(0),
                                                yValue: api.value(1),
                                                x: location[0],
                                                y: location[1],
                                                xAxisPoint: api.coord([api.value(0), 0])
                                            },
                                            style: {
                                                fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                    offset: 0,
                                                    color: 'rgba(48,165,248,1)' // 28,137,245
                                                },
                                                {
                                                    offset: 1,
                                                    color: 'rgba(48,165,248,1)'
                                                }
                                                ])
                                            }
                                        }]
                                    }
                                },
                                data: data[0].data
                            }, {
                                type: 'bar',
                                name: data[0].name,
                                barWidth: 25,
                                label: {
                                    normal: {
                                        show: false
                                    }
                                },
                                itemStyle: {
                                    color: 'transparent'
                                },
                                data: data[0].data
                            }, {
                                type: 'line',
                                name: data[1].name,
                                yAxisIndex: 1,
                                label: {
                                    normal: {
                                        show: false
                                    }
                                },
                                itemStyle: {
                                    color: '#f6c229'
                                },
                                data: data[1].data
                            }]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 水球图(三层波浪)
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} legendShow  是否显示图例
                     */
                    getWaterPoloOption(id, name, data, tabTypeDf, iftxtcolor, top) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!iftxtcolor) {
                            iftxtcolor = false
                        }
                        if (top) {

                        }
                        var seriesData = []
                        data.map(item => {
                            var str = {
                                type: 'liquidFill',
                                data: [item.value / 100, item.value / 100 - 0.1, item.value / 100 - 0.2],
                                radius: item.radius,
                                center: item.center,
                                color: ['rgba(' + item.color + ', .5)', 'rgba(' + item.color + ', .7)', 'rgba(' + item.color + ', 1)'],
                                backgroundStyle: {
                                    borderWidth: 2,
                                    borderColor: 'rgba(' + item.color + ', 1)',
                                    shadowBlur: 0,
                                    shadowColor: 'rgba(' + item.color + ', 1)',
                                    color: 'transparent'
                                },
                                itemStyle: {
                                    shadowBlur: 0,
                                    shadowColor: 'rgba(' + item.color + ', 1)'
                                },
                                outline: {
                                    show: false
                                },
                                label: {
                                    fontSize: xyTextSize,
                                    position: id === 'WaterPoloEcharts' ? (clientWidth > 1025 ? ['50%', '80%'] : ['50%', '80%']) : ['50%', '80%'],
                                    formatter: () => {
                                        if (id === 'WaterPoloEcharts') {
                                            if (clientWidth > 1025) {
                                                return item.name + '\n' + (item.heart).toFixed(2) + '\n\n\n\n' + item.value + '%'
                                            } else {
                                                return item.name + '\n' + (item.heart).toFixed(2) + '\n\n' + item.value + '%'
                                            }
                                        } else {
                                            return item.name + '\n' + (item.heart).toFixed(2) + '\n\n\n\n' + item.value + '%'
                                        }
                                    },
                                    color: iftxtcolor ? darkColor : xyTextColor
                                }
                            }
                            seriesData.push(str)
                        })

                        let option = {
                            title: {
                                text: `单位：${tabTypeDf === 0 ? '万吨标煤' : '万吨CO₂'}`,
                                left: 'center',
                                bottom: clientWidth > 1025 ? '0%' : '-3%',
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: iftxtcolor ? darkColor : xyTextColor
                                }
                            },
                            series: seriesData
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 双折线图（双轴）
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} xData  x轴数据
                     * @param {*} colors  颜色数组
                     * @param {*} legendShow  是否显示图例
                     */
                    getLineTwoOpiton(id, name, data, xData, colors, legendShow, iftxtcolor) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!colors) {
                            colors = ['#5b9bd5', '#ed7d31', '#a5a5a5', '#ffc003', '#4472c4', '#70ad47']
                        }
                        if (!legendShow) {
                            legendShow = false
                        }
                        if (!iftxtcolor) {
                            iftxtcolor = false
                        }
                        var legendData = []
                        var seriesData = []
                        var MAXNUM = data[0].data
                        var MINNUM = data[1].data
                        data.map(item => {
                            var str = {
                                name: item.name,
                                type: 'line',
                                data: item.data,
                                lineStyle: {
                                    normal: {
                                        width: 2
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        borderWidth: 2
                                    }
                                },
                                smooth: true
                            }
                            seriesData.push(str)
                            legendData.push(item.name)
                        })

                        let option = {
                            tooltip: {
                                trigger: 'axis',
                                formatter: (params) => {
                                    var html = '<div>'
                                    html += '   <span style="color:#fff">' + params[0].name + '</span> <br/>'
                                    params.map((item, i) => {
                                        html += params[i].marker
                                        html += '   <span style="color:#fff">' + params[i].seriesName + '：</span>'
                                        html += '   <span style="color:#fff">' + params[i].data === 'null' || params[i].data === null ? 0 : params[i].data + '</span>'
                                        html += '   <span style="color:#fff">' + data[i].unit + '</span> <br/>'
                                    })
                                    html += '</div>'

                                    return html
                                }
                            },
                            color: colors,
                            legend: {
                                show: legendShow,
                                data: legendData,
                                left: 'center',
                                top: -3,
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: iftxtcolor ? darkColor : xyTextColor
                                }
                            },
                            grid: {
                                top: clientWidth > 1025 ? '15%' : '25%',
                                left: '3%',
                                right: '4%',
                                bottom: '5%',
                                containLabel: true
                            },
                            xAxis: {
                                type: 'category',
                                data: xData,
                                axisLine: {
                                    lineStyle: {
                                        color: iftxtcolor ? darksplitLine : xyTextColor
                                    }
                                },
                                axisLabel: {
                                    show: true,
                                    rotate: 45,
                                    interval: 0,
                                    textStyle: {
                                        color: iftxtcolor ? darkColor : xyTextColor,
                                        fontSize: xyTextSize
                                    },
                                    margin: 10,
                                    formatter: function (val) {
                                        return val
                                    }
                                }
                            },
                            yAxis: [{
                                type: 'value',
                                name: data[0].name + ': ' + data[0].unit,
                                nameTextStyle: {
                                    color: iftxtcolor ? darkColor : xyTextColor,
                                    fontSize: xyTextSize,
                                    padding: [0, 0, 0, 30]
                                },
                                position: 'left',
                                min: (parseInt(Math.min(...MAXNUM) / 1000)) <= 0 ? 0 : ((parseInt(Math.min(...MAXNUM) / 1000)) <= 5 ? ((parseInt(Math.min(...MAXNUM) / 1000) - 1) * 1000) : ((parseInt(Math.min(...MAXNUM) / 1000) - 4) * 1000)), // 取最小值为最小刻度
                                max: (parseInt(Math.max(...MAXNUM))) <= 500 ? (parseInt(Math.max(...MAXNUM) / 100) + 1) * 100 : (parseInt(Math.max(...MAXNUM) / 1000) + 1) * 1000, // 取最大值为最大刻度
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        type: 'dashed',
                                        color: iftxtcolor ? darksplitLine : '#DDD'
                                    }
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: iftxtcolor ? darksplitLine : xyTextColor
                                    }
                                },
                                splitArea: {
                                    show: false
                                },
                                axisLabel: {
                                    textStyle: {
                                        color: iftxtcolor ? darkColor : xyTextColor
                                    }
                                }
                            }, {
                                type: 'value',
                                name: data[1].name + ': ' + data[1].unit,
                                nameTextStyle: {
                                    color: iftxtcolor ? darkColor : xyTextColor,
                                    fontSize: xyTextSize,
                                    padding: [0, 50, 0, 0]
                                },
                                position: 'right',
                                min: (parseInt(Math.min(...MINNUM))) <= 0 ? 0 : (parseInt(Math.min(...MINNUM))), // 取最小值为最小刻度
                                max: (parseInt(Math.min(...MAXNUM))) > 5000 ? (parseInt(Math.max(...MINNUM)) + 2) * 1 : (parseInt(Math.max(...MINNUM)) + 1) * 2, // 取最大值为最大刻度
                                splitLine: {
                                    show: false,
                                    lineStyle: {
                                        type: 'dashed',
                                        color: iftxtcolor ? darksplitLine : '#DDD'
                                    }
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: iftxtcolor ? darksplitLine : xyTextColor
                                    }
                                },
                                splitArea: {
                                    show: false
                                },
                                axisLabel: {
                                    textStyle: {
                                        color: iftxtcolor ? darkColor : xyTextColor
                                    }
                                }
                            }],
                            series: [
                                {
                                    name: data[0].name,
                                    type: 'line',
                                    gridIndex: 0,
                                    data: data[0].data
                                },
                                {
                                    name: data[1].name,
                                    type: 'line',
                                    yAxisIndex: 1,
                                    data: data[1].data
                                }
                            ]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                     /**
                     * 全景驾驶舱双折线图（双轴）
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} xData  x轴数据
                     * @param {*} colors  颜色数组
                     * @param {*} legendShow  是否显示图例
                     */
                    getLineTwoOpitonAllCar(id, name, data, xData, colors, legendShow, iftxtcolor) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!colors) {
                            colors = ['#5b9bd5', '#ed7d31', '#a5a5a5', '#ffc003', '#4472c4', '#70ad47']
                        }
                        if (!legendShow) {
                            legendShow = false
                        }
                        if (!iftxtcolor) {
                            iftxtcolor = false
                        }
                        var legendData = []
                        var seriesData = []
                        var MAXNUM = data[0].data
                        var MINNUM = data[1].data
                        data.map(item => {
                            var str = {
                                name: item.name,
                                type: 'line',
                                data: item.data,
                                lineStyle: {
                                    normal: {
                                        width: 2
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        borderWidth: 2
                                    }
                                },
                                smooth: true
                            }
                            seriesData.push(str)
                            legendData.push(item.name)
                        })

                        let option = {
                            tooltip: {
                                trigger: 'axis',
                                confine: false,
                                position: ['30%', '40%'],
                                formatter: (params) => {
                                    var html = '<div>'
                                    html += '   <span style="color:#fff">' + params[0].name + '</span> <br/>'
                                    params.map((item, i) => {
                                        html += params[i].marker
                                        html += '   <span style="color:#fff">' + params[i].seriesName + '：</span>'
                                        html += '   <span style="color:#fff">' + params[i].data === 'null' || params[i].data === null ? 0 : params[i].data + '</span>'
                                        html += '   <span style="color:#fff">' + data[i].unit + '</span> <br/>'
                                    })
                                    html += '</div>'

                                    return html
                                }
                            },
                            color: colors,
                            legend: {
                                show: legendShow,
                                data: legendData,
                                left: 'center',
                                top: -3,
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: iftxtcolor ? darkColor : xyTextColor
                                }
                            },
                            grid: {
                                top: clientWidth > 1025 ? '15%' : '25%',
                                left: '3%',
                                right: '4%',
                                bottom: '5%',
                                containLabel: true
                            },
                            xAxis: {
                                type: 'category',
                                data: xData,
                                axisLine: {
                                    lineStyle: {
                                        color: iftxtcolor ? darksplitLine : xyTextColor
                                    }
                                },
                                axisLabel: {
                                    show: true,
                                    rotate: 45,
                                    interval: 0,
                                    textStyle: {
                                        color: iftxtcolor ? darkColor : xyTextColor,
                                        fontSize: xyTextSize
                                    },
                                    margin: 10,
                                    formatter: function (val) {
                                        return val
                                    }
                                }
                            },
                            yAxis: [{
                                type: 'value',
                                name: data[0].name + ': ' + data[0].unit,
                                nameTextStyle: {
                                    color: iftxtcolor ? darkColor : xyTextColor,
                                    fontSize: xyTextSize,
                                    padding: [0, 0, 0, 30]
                                },
                                position: 'left',
                                min: (parseInt(Math.min(...MAXNUM) / 1000)) <= 0 ? 0 : ((parseInt(Math.min(...MAXNUM) / 1000)) <= 5 ? ((parseInt(Math.min(...MAXNUM) / 1000) - 1) * 1000) : ((parseInt(Math.min(...MAXNUM) / 1000) - 4) * 1000)), // 取最小值为最小刻度
                                max: (parseInt(Math.max(...MAXNUM))) <= 500 ? (parseInt(Math.max(...MAXNUM) / 100) + 1) * 100 : (parseInt(Math.max(...MAXNUM) / 1000) + 1) * 1000, // 取最大值为最大刻度
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        type: 'dashed',
                                        color: iftxtcolor ? darksplitLine : '#DDD'
                                    }
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: iftxtcolor ? darksplitLine : xyTextColor
                                    }
                                },
                                splitArea: {
                                    show: false
                                },
                                axisLabel: {
                                    textStyle: {
                                        color: iftxtcolor ? darkColor : xyTextColor
                                    }
                                }
                            }, {
                                type: 'value',
                                name: data[1].name + ': ' + data[1].unit,
                                nameTextStyle: {
                                    color: iftxtcolor ? darkColor : xyTextColor,
                                    fontSize: xyTextSize,
                                    padding: [0, 50, 0, 0]
                                },
                                position: 'right',
                                min: (parseInt(Math.min(...MINNUM))) <= 0 ? 0 : (parseInt(Math.min(...MINNUM))), // 取最小值为最小刻度
                                max: (parseInt(Math.min(...MAXNUM))) > 5000 ? (parseInt(Math.max(...MINNUM)) + 2) * 1 : (parseInt(Math.max(...MINNUM)) + 1) * 2, // 取最大值为最大刻度
                                splitLine: {
                                    show: false,
                                    lineStyle: {
                                        type: 'dashed',
                                        color: iftxtcolor ? darksplitLine : '#DDD'
                                    }
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: iftxtcolor ? darksplitLine : xyTextColor
                                    }
                                },
                                splitArea: {
                                    show: false
                                },
                                axisLabel: {
                                    textStyle: {
                                        color: iftxtcolor ? darkColor : xyTextColor
                                    }
                                }
                            }],
                            series: [
                                {
                                    name: data[0].name,
                                    type: 'line',
                                    gridIndex: 0,
                                    data: data[0].data
                                },
                                {
                                    name: data[1].name,
                                    type: 'line',
                                    yAxisIndex: 1,
                                    data: data[1].data
                                }
                            ]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 圆球图（阴影边框）
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     */
                    getScatterOption(id, name, data) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        var plantCap = [
                            {
                                name: '2022',
                                value: '22'
                            },
                            {
                                name: '2025',
                                value: '25'
                            }, {
                                name: '2023',
                                value: '23'
                            },
                            {
                                name: '2020',
                                value: '18.8'
                            }, {
                                name: '2021',
                                value: '20'
                            }, {
                                name: '2024',
                                value: '24'
                            }
                        ]

                        var datalist = [
                            {
                                offset: [15, 70],
                                symbolSize: 22 * 4,
                                opacity: 0.95,
                                color: 'rgba(171,112,213, 0.95)'
                            },
                            {
                                offset: [50, 85],
                                symbolSize: 25 * 4,
                                opacity: 0.95,
                                color: 'rgba(91,143,249, 0.95)'
                            }, {
                                offset: [90, 76],
                                symbolSize: 23 * 4,
                                opacity: 0.95,
                                color: 'rgba(34,181,239, 0.95)'
                            },
                            {
                                offset: [20, 40],
                                symbolSize: 18.8 * 4,
                                opacity: 0.95,
                                color: 'rgba(246,189,22, 0.90)'
                            }, {
                                offset: [55, 50],
                                symbolSize: 20 * 4,
                                opacity: 0.95,
                                color: 'rgba(255,152,68, 0.90)'
                            }, {
                                offset: [90, 45],
                                symbolSize: 24 * 4,
                                opacity: 0.95,
                                color: 'rgba(0,200,120, 0.85)'
                            }
                        ]
                        var datas = []
                        for (var i = 0; i < plantCap.length; i++) {
                            var item = plantCap[i]
                            var itemToStyle = datalist[i]
                            datas.push({
                                name: item.value + '\n' + item.name,
                                value: itemToStyle.offset,
                                symbolSize: itemToStyle.symbolSize,
                                label: {
                                    normal: {
                                        textStyle: {
                                            fontSize: 14,
                                            color: i < 3 ? '#fff' : '#000'
                                        }
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        color: itemToStyle.color,
                                        opacity: itemToStyle.opacity,
                                        borderWidth: '4',
                                        borderType: 'solid',
                                        borderColor: '#fff',
                                        shadowColor: itemToStyle.color,
                                        shadowBlur: 10
                                    }
                                }
                            })
                        }

                        let option = {
                            title: {
                                text: '非化石能源占比（%）',
                                left: 'center',
                                bottom: '10%',
                                textStyle: {
                                    fontSize: 16,
                                    fontWeight: 'normal',
                                    color: ['#000']
                                }
                            },
                            grid: {
                                show: false,
                                top: 10,
                                bottom: 10
                            },
                            xAxis: [{
                                gridIndex: 0,
                                type: 'value',
                                show: false,
                                min: 0,
                                max: 100,
                                nameLocation: 'middle',
                                nameGap: 5
                            }],
                            yAxis: [{
                                gridIndex: 0,
                                min: 0,
                                show: false,
                                max: 100,
                                nameLocation: 'middle',
                                nameGap: 30
                            }],
                            series: [{
                                type: 'scatter',
                                symbol: 'circle',
                                symbolSize: 120,
                                label: {
                                    normal: {
                                        show: true,
                                        formatter: '{b}',
                                        color: '#fff',
                                        textStyle: {
                                            fontSize: '20'
                                        }
                                    }
                                },
                                data: datas
                            }]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 环形图（半环）
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     */
                    getRingOption(id, name, data) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        var color = ['#5B8FF9', '#1FB4EF', '#00C878', '#AA6FD5', '#FF9743', '#F6BD16']
                        var chartData = [{
                            name: 'NO.1',
                            value: 56.00,
                            unit: '2025年'
                        },
                        {
                            name: 'NO.2',
                            value: 54.33,
                            unit: '2024年'
                        },
                        {
                            name: 'NO.3',
                            value: 53.36,
                            unit: '2023年'
                        },
                        {
                            name: 'NO.4',
                            value: 52.55,
                            unit: '2022年'
                        },
                        {
                            name: 'NO.5',
                            value: 52.55,
                            unit: '2021年'
                        },
                        {
                            name: 'NO.6',
                            value: 51.81,
                            unit: '2020年'
                        }
                        ]
                        var arrName = []
                        var arrValue = []
                        var sum = 75
                        // eslint-disable-next-line one-var
                        var pieSeries = [], lineYAxis = []

                        // 数据处理
                        chartData.forEach((v, i) => {
                            arrName.push(v.name)
                            arrValue.push(v.value)
                        })

                        // 图表option整理
                        chartData.forEach((v, i) => {
                            pieSeries.push({
                                name: '沪昆线到达晚点情况',
                                type: 'pie',
                                clockWise: false,
                                hoverAnimation: false,
                                radius: [82 - i * 12 + '%', 77 - i * 12 + '%'],
                                center: ['50%', '48%'],
                                label: {
                                    show: false
                                },
                                data: [{
                                    value: v.value,
                                    name: v.name
                                },
                                {
                                    value: sum - v.value,
                                    name: '',
                                    itemStyle: {
                                        color: 'rgba(0,0,0,0)'
                                    }
                                }
                                ]
                            })
                            // pieSeries.push({
                            //     name: '',
                            //     type: 'pie',
                            //     silent: true,
                            //     z: 1,
                            //     clockWise: false, // 顺时加载
                            //     hoverAnimation: false, // 鼠标移入变大
                            //     radius: [80 - i * 15 + '%', 77 - i * 15 + '%'],
                            //     center: ['40%', '50%'],
                            //     label: {
                            //         show: false
                            //     },
                            //     data: [{
                            //         value: 7.5,
                            //         itemStyle: {
                            //             color: '#fff'
                            //         }
                            //     }, {
                            //         value: 2.5,
                            //         name: '',
                            //         itemStyle: {
                            //             color: 'rgba(0,0,0,0)'
                            //         }
                            //     }]
                            // })
                            v.percent = (v.value).toFixed(2)
                            lineYAxis.push({
                                value: i,
                                textStyle: {
                                    rich: {
                                        circle: {
                                            color: color[i],
                                            padding: [0, 5]
                                        },
                                        line: {
                                            width: 30,
                                            height: 10
                                        },
                                        name: {
                                            color: color[i],
                                            fontSize: 14
                                        },
                                        bd: {
                                            color: color[i],
                                            padding: [0, 5],
                                            fontSize: 14
                                        },
                                        percent: {
                                            color: color[i],
                                            fontSize: 14
                                        },
                                        value: {
                                            color: color[i],
                                            fontSize: 16,
                                            fontWeight: 500,
                                            padding: [0, 0, 0, 20]
                                        },
                                        unit: {
                                            color: color[i],
                                            fontSize: 14
                                        }
                                    }
                                }
                            })
                        })

                        let option = {
                            backgroundColor: '#fff',
                            color: color,
                            title: {
                                text: '消费端碳排放（万吨）',
                                textStyle: {
                                    color: '#333',
                                    fontSize: 16
                                },
                                left: 'center',
                                top: 'bottom'
                            },
                            grid: {
                                top: '7%',
                                bottom: '58%',
                                left: '45%',
                                containLabel: false
                            },
                            yAxis: [{
                                type: 'category',
                                inverse: true,
                                axisLine: {
                                    show: false
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLabel: {
                                    formatter: function (params) {
                                        let item = chartData[params]
                                        return '{line|}{circle|●}{name|' + item.name + '}{bd|}{unit|' + item.unit + '}{bd|}{percent|' + item.percent + '}'
                                    },
                                    interval: 0,
                                    inside: true,
                                    show: true
                                },
                                data: lineYAxis
                            }],
                            xAxis: [{
                                show: false
                            }],
                            series: pieSeries
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 漏斗图
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} colors  颜色数组
                     */
                    getFunnelOption(id, name, data, colors) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }

                        var num = [500, 600, 700, 800, 900, 1000]
                        var seriesData = []
                        data.map((item, i) => {
                            var str = {
                                value: item.value,
                                name: item.name,
                                itemStyle: {
                                    normal: {
                                        color: colors[i]
                                    }
                                }
                            }
                            seriesData.push(str)
                        })

                        let option = {
                            title: {
                                text: '绿色化改造（个）',
                                bottom: '10%',
                                left: '35%',
                                textStyle: {
                                    color: '#333',
                                    fontSize: 16
                                }
                            },
                            tooltip: {
                                trigger: 'item',
                                formatter: function (params) {
                                    var html = '<div>'
                                    html += '   <span style="color:#fff">绿色化改造</span> <br/>'
                                    html += params.marker
                                    html += '   <span style="color:#fff">' + params.name + '</span>：'
                                    html += '   <span style="color:#fff">' + num[params.dataIndex] + '个</span> '
                                    // html += '   <span style="color:#fff">' + params.value + '个</span> '
                                    html += '   <span style="color:#fff"> ' + params.percent + '%</span> <br/>'
                                    html += '</div>'

                                    return html
                                }
                            },
                            legend: {
                                show: false
                            },
                            grid: {
                                top: 24,
                                left: -20,
                                right: 20,
                                bottom: '30%',
                                containLabel: true
                                // borderWidth: 0.5
                            },
                            series: [
                                {
                                    top: 0,
                                    name: '',
                                    type: 'funnel',
                                    height: '300',
                                    left: '10%',
                                    width: '80%',
                                    gap: 0,
                                    minSize: '40%',
                                    maxSize: '80%',
                                    label: {
                                        normal: {
                                            color: '#353535',
                                            position: 'right'
                                        },
                                        emphasis: {
                                            position: 'right',
                                            // formatter: '{c}%',
                                            label: {
                                                fontSize: 20
                                            }
                                        }
                                    },
                                    labelLine: {
                                        normal: {
                                            length: 40,
                                            position: 'right',
                                            lineStyle: {
                                                color: '#ccc',
                                                width: 2
                                            }
                                        }
                                    },
                                    data: seriesData
                                },
                                {
                                    name: '',
                                    type: 'funnel',
                                    height: '300',
                                    top: 0,
                                    gap: 5,
                                    label: {
                                        normal: {
                                            position: 'inside',
                                            // formatter: '{c}', // '转化率：({c}%)',
                                            formatter: function (p) {
                                                return num[p.dataIndex]
                                            },
                                            textStyle: {
                                                color: '#333'
                                            }
                                        }
                                    },
                                    itemStyle: {
                                        normal: {
                                            color: 'transparent',
                                            borderWidth: 0,
                                            opacity: 0
                                        }
                                    },
                                    data: data
                                }
                            ]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 仪表盘
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} colors  颜色数组
                     */
                    getDashboardOption(id, name, data, colors) {
                        var getmax = 100
                        var getvalue = 60

                        let option = {
                            backgroundColor: '#FFFFFF',
                            // title: [{
                            //     text: '全校承担本科教学任务的教授比率',
                            //     bottom: '6%',
                            //     x: 'center',
                            //     borderColor: '#1598FF',
                            //     borderWidth: 1,
                            //     borderRadius: 15,
                            //     backgroundColor: '#1598FF',
                            //     padding: [7, 14],
                            //     textStyle: {
                            //         fontWeight: 'bold',
                            //         fontSize: 13,
                            //         color: '#fff'
                            //     }
                            // }],
                            title: [{
                                text: '公布项目个数',
                                bottom: '20%',
                                x: 'center'
                            }],
                            angleAxis: {
                                show: false,
                                max: getmax * 360 / 270, // -45度到225度，二者偏移值是270度除360度
                                type: 'value',
                                startAngle: 225, // 极坐标初始角度
                                splitLine: {
                                    show: false
                                }
                            },
                            barMaxWidth: 20, // 圆环宽度
                            radiusAxis: {
                                show: false,
                                type: 'category'
                            },
                            // 圆环位置和大小
                            polar: {
                                center: ['50%', '50%'],
                                radius: '120%'
                            },
                            series: [{
                                type: 'bar',
                                data: [{ // 上层圆环，显示数据
                                    value: getvalue,
                                    itemStyle: {
                                        color: '#1598FF'
                                    }
                                }],
                                barGap: '-100%', // 柱间距离,上下两层圆环重合
                                coordinateSystem: 'polar',
                                roundCap: true, // 顶端圆角
                                z: 3 // 圆环层级，同zindex
                            },
                            { // 下层圆环，显示最大值
                                type: 'bar',
                                data: [{
                                    value: getmax,
                                    itemStyle: {
                                        color: '#1598FF',
                                        opacity: 0.2,
                                        borderWidth: 0
                                    }
                                }],
                                barGap: '-100%',
                                coordinateSystem: 'polar',
                                roundCap: true,
                                z: 1
                            },
                            // 仪表盘
                            {
                                type: 'gauge',
                                startAngle: 225, // 起始角度，同极坐标
                                endAngle: -45, // 终止角度，同极坐标
                                axisLine: {
                                    show: false
                                },
                                splitLine: {
                                    show: false
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLabel: {
                                    show: false
                                },
                                splitLabel: {
                                    show: false
                                },
                                pointer: { // 分隔线
                                    shadowColor: 'auto', // 默认透明
                                    shadowBlur: 5,
                                    length: '50%',
                                    width: '2'
                                },
                                itemStyle: {
                                    color: '#1598FF',
                                    borderColor: '#1598FF',
                                    borderWidth: 6
                                },
                                detail: {
                                    formatter: function (params) {
                                        return '29846' // 下方文字
                                    },
                                    color: '#000',
                                    fontSize: 20,
                                    offsetCenter: [0, 150] // 文字位置
                                },
                                title: {
                                    show: false
                                },
                                data: [{
                                    value: getvalue
                                }]
                            }, {
                                name: '外部刻度',
                                type: 'gauge',
                                //  center: ['20%', '50%'],
                                radius: '73%',
                                min: 0, // 最小刻度
                                max: 100, // 最大刻度
                                splitNumber: 10, // 刻度数量
                                startAngle: 225,
                                endAngle: -45,
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        width: 1,
                                        color: [
                                            [1, 'rgba(0,0,0,0)']
                                        ]
                                    }
                                }, // 仪表盘轴线
                                axisLabel: {
                                    show: false,
                                    color: '#4d5bd1',
                                    distance: 25
                                },
                                axisTick: { // 刻度标签。
                                    show: false,
                                    splitNumber: 7,
                                    lineStyle: {
                                        color: '#C7CBCF', // 用颜色渐变函数不起作用
                                        width: 2
                                    },
                                    length: -8
                                }, // 刻度样式
                                splitLine: {
                                    show: false,
                                    length: -20,
                                    lineStyle: {
                                        color: '#C7CBCF' // 用颜色渐变函数不起作用
                                    }
                                }, // 分隔线样式
                                detail: {
                                    show: false
                                },
                                pointer: {
                                    show: false
                                }
                            }, { // 指针外环
                                type: 'pie',
                                hoverAnimation: false,
                                legendHoverLink: false,
                                radius: ['5%', '10%'],
                                z: 1222, // 指针圆环
                                label: {
                                    normal: {
                                        show: false
                                    }
                                },
                                labelLine: {
                                    normal: {
                                        show: false
                                    }
                                },
                                data: [{
                                    value: 100,
                                    itemStyle: {
                                        normal: {
                                            color: '#1598FF'
                                        }
                                    }
                                }]
                            },
                            { // 指针内环
                                type: 'pie',
                                hoverAnimation: false,
                                legendHoverLink: false,
                                radius: ['0%', '10%'],
                                z: 10,
                                label: {
                                    normal: {
                                        show: false
                                    }
                                },
                                labelLine: {
                                    normal: {
                                        show: false
                                    }
                                },
                                data: [{
                                    value: 100,
                                    itemStyle: {
                                        normal: {
                                            color: '#FFFFFF'
                                        }
                                    }
                                }]
                            }
                            ]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 多条折线图
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} xData  x轴数据
                     * @param {*} colors  颜色数组
                     * @param {*} legendShow  是否显示图例
                     */
                    getLinesCompleteOption(id, name, data, xData, colors, legendShow, textColor) {
                        if (!name) {
                            name = ''
                        }
                        if (!colors) {
                            colors = ['#5b9bd5', '#ed7d31', '#a5a5a5', '#ffc003', '#4472c4', '#70ad47']
                        }
                        if (!legendShow) {
                            legendShow = false
                        }
                        let legendData = []
                        let seriesData = []
                        console.log(data, 'data')
                        if (data !== 'false') {
                            data.map((item, index) => {
                                var str = {
                                    name: item.name,
                                    type: 'line',
                                    data: item.value,
                                    label: {
                                        show: true,
                                        position: 'top',
                                        textStyle: {
                                            fontSize: xyTextSize
                                        }
                                    },
                                    itemStyle: {
                                        color: colors[index]
                                    }
                                }
                                seriesData.push(str)
                                legendData.push(item.name)
                            })
                        }

                        let option = {
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                                    type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                                },
                                formatter: function (params) {
                                    var relVal = params[0].name + '年各区县项目完成情况：'
                                    for (var i = 0, l = params.length; i < l; i++) {
                                        relVal += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + '个'
                                    }
                                    return relVal
                                }
                            },
                            legend: {
                                show: legendShow,
                                data: legendData,
                                bottom: 5,
                                left: 'center',
                                itemGap: 2,
                                itemWidth: 15,
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: textColor ? textColor : '#606266'
                                }
                            },
                            grid: {
                                left: data !== 'false' ? '3%' : '10%',
                                right: '4%',
                                bottom: '15%',
                                top: '12%',
                                containLabel: true
                            },
                            xAxis: {
                                type: 'category',
                                boundaryGap: true,
                                data: xData,
                                axisLabel: {
                                    textStyle: {
                                        fontSize: xyTextSize,
                                        color: textColor ? textColor : xyTextColor
                                    }
                                },
                                axisLine: {
                                    lineStyle: {
                                        color: '#a9a9a9'
                                    }
                                }
                            },
                            yAxis: {
                                type: 'value',
                                name: '单位：个',
                                axisLabel: {
                                    textStyle: {
                                        fontSize: xyTextSize,
                                        color: textColor ? textColor : xyTextColor
                                    }
                                },
                                axisLine: {
                                    lineStyle: {
                                        color: '#a9a9a9'
                                    }
                                }
                            },
                            series: seriesData
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    getLinesCompleteOption1(id, name, data, xData, colors, legendShow) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!colors) {
                            colors = ['#5b9bd5', '#ed7d31', '#a5a5a5', '#ffc003', '#4472c4', '#70ad47']
                        }
                        if (!legendShow) {
                            legendShow = false
                        }
                        let legendData = []
                        let seriesData = []
                        console.log(data, 'data')
                        data.map((item, index) => {
                            var str = {
                                name: item.name,
                                type: 'line',
                                data: item.value,
                                label: {
                                    show: true,
                                    position: 'top',
                                    textStyle: {
                                        fontSize: xyTextSize
                                    }
                                },
                                itemStyle: {
                                    color: colors[index]
                                }
                            }
                            seriesData.push(str)
                            legendData.push(item.name)
                        })

                        let option = {
                            color: [
                                "#11B922",
                                "#44CBF0",
                                "#FABD00",
                                "#4991FF",
                                "#009794",
                                "#FF9128",
                                "#FA5949",
                            ],
                            tooltip: {
                                trigger: "axis",
                                formatter: (params) => {
                                    var result = params[0].name + "<br>";
                                    params.forEach((item) => {
                                        const value = item.data ? item.data : "";
                                        result +=
                                            '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' +
                                            item.color +
                                            '"></span>';
                                        result += item.seriesName + " : " + value + "万吨CO₂<br>";
                                    });
                                    return result;
                                },
                            },
                            legend: {
                                right: "12px",
                                top: "0",
                                type: "scroll",
                                textStyle: {
                                    color: "#999999",
                                },
                                data: legendData,
                            },
                            grid: [
                                {
                                    left: "40px",
                                    bottom: "30px",
                                    top: "50px",
                                    right: "20px",
                                },
                            ],
                            xAxis: {
                                type: "category",
                                axisLine: {
                                    lineStyle: {
                                        color: "#999999",
                                    },
                                },
                                axisTick: {
                                    show: false,
                                },
                                data: xData,
                            },
                            yAxis: {
                                type: "value",
                                name: "单位：万吨CO₂",
                                axisTick: {
                                    show: false,
                                },
                                axisLine: {
                                    show: false,
                                    lineStyle: {
                                        color: "#999999",
                                    },
                                },
                            },
                            series: seriesData,
                        };

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 单柱图
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} xData  x轴数据
                     * @param {*} colors  颜色数组
                     * @param {*} legendShow  是否显示图例
                     *  * @param {*} dwName  单位名字
                     * 
                     */
                    getTouZiOption(id, name, data, xData, colors, legendShow, textColor, dwName) {
                        if (!name) {
                            name = ''
                        }
                        // if (!data) {
                        //     data = []
                        // }
                        if (!colors) {
                            colors = ['#5b9bd5', '#ed7d31', '#a5a5a5', '#ffc003', '#4472c4', '#70ad47']
                        }
                        if (!legendShow) {
                            legendShow = false
                        }
                        let newdwName = ''
                        if (dwName) {
                            newdwName = dwName
                        } else {
                            newdwName = '万元'
                        }
                        let option = {
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                                    type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                                },
                                formatter: function (params) {
                                    var relVal = params[0].name
                                    for (var i = 0, l = params.length; i < l; i++) {
                                        relVal += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + newdwName
                                    }
                                    return relVal
                                }
                            },
                            grid: {
                                left: dwName ? '6%' : data !== 'false' ? '1%' : '10%',
                                right: '1%',
                                bottom: '3%',
                                top: '14%',
                                containLabel: true
                            },
                            legend: {
                                show: legendShow,
                                data: name,
                                right: 0,
                                textStyle: {
                                    fontSize: xyTextSize
                                }
                            },
                            xAxis: [
                                {
                                    type: 'category',
                                    axisLabel: {
                                        textStyle: {
                                            fontSize: xyTextSize,
                                            color: textColor ? textColor : xyTextColor
                                        },
                                        interval: 0,
                                        rotate: 30
                                    },
                                    axisLine: {
                                        lineStyle: {
                                            color: "#A9A9A9",
                                        },
                                    },
                                    data: xData
                                }
                            ],
                            yAxis: [
                                {
                                    type: 'value',
                                    name: dwName || '单位：万元',
                                    splitLine: {
                                        show: false
                                    },
                                    axisLabel: {
                                        textStyle: {
                                            fontSize: xyTextSize,
                                            color: textColor ? textColor : xyTextColor
                                        }
                                    },
                                    axisLine: {
                                        lineStyle: {
                                            color: "#A9A9A9",
                                        },
                                    },
                                }
                            ],
                            series: [
                                {
                                    name: data !== 'false' ? name : '',
                                    type: 'bar',
                                    itemStyle: {
                                        normal: {
                                            color: '#5B90FA',
                                            label: {
                                                show: false,
                                                position: 'top',
                                                textStyle: {
                                                    color: '#5B90FA',
                                                    fontSize: xyTextSize
                                                }
                                            }
                                        }
                                    },
                                    barWidth: 20,
                                    emphasis: {
                                        focus: 'series'
                                    },
                                    data: data !== 'false' ? data : []
                                }
                            ]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 单柱图滑动定位
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} xData  x轴数据
                     * @param {*} colors  颜色数组
                     * @param {*} legendShow  是否显示图例
                     *  * @param {*} dwName  单位名字
                     * @param {*} hovePosition  滑动内容位置
                     */
                    getTouZiOptionDw(id, name, data, xData, colors, legendShow, textColor, dwName,hovePosition) {
                        if (!name) {
                            name = ''
                        }
                        // if (!data) {
                        //     data = []
                        // }
                        if (!colors) {
                            colors = ['#5b9bd5', '#ed7d31', '#a5a5a5', '#ffc003', '#4472c4', '#70ad47']
                        }
                        if (!legendShow) {
                            legendShow = false
                        }
                        if (hovePosition) {
                            hovePosition = true
                        } else {
                            hovePosition = false
                        }
                        let newdwName = ''
                        if (dwName) {
                            newdwName = dwName
                        } else {
                            newdwName = '万元'
                        }
                        let option = {
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                                    type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                                },
                                confine: hovePosition?false:true,
                                position: hovePosition?['30%', '40%']:[],
                                formatter: function (params) {
                                    var relVal = params[0].name
                                    for (var i = 0, l = params.length; i < l; i++) {
                                        relVal += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + newdwName
                                    }
                                    return relVal
                                }
                            },
                            grid: {
                                left: dwName ? '6%' : data !== 'false' ? '1%' : '10%',
                                right: '1%',
                                bottom: '3%',
                                top: '14%',
                                containLabel: true
                            },
                            legend: {
                                show: legendShow,
                                data: name,
                                right: 0,
                                textStyle: {
                                    fontSize: xyTextSize
                                }
                            },
                            xAxis: [
                                {
                                    type: 'category',
                                    axisLabel: {
                                        textStyle: {
                                            fontSize: xyTextSize,
                                            color: textColor ? textColor : xyTextColor
                                        },
                                        interval: 0,
                                        rotate: 30
                                    },
                                    axisLine: {
                                        lineStyle: {
                                            color: "#A9A9A9",
                                        },
                                    },
                                    data: xData
                                }
                            ],
                            yAxis: [
                                {
                                    type: 'value',
                                    name: dwName || '单位：万元',
                                    splitLine: {
                                        show: false
                                    },
                                    axisLabel: {
                                        textStyle: {
                                            fontSize: xyTextSize,
                                            color: textColor ? textColor : xyTextColor
                                        }
                                    },
                                    axisLine: {
                                        lineStyle: {
                                            color: "#A9A9A9",
                                        },
                                    },
                                }
                            ],
                            series: [
                                {
                                    name: data !== 'false' ? name : '',
                                    type: 'bar',
                                    itemStyle: {
                                        normal: {
                                            color: '#5B90FA',
                                            label: {
                                                show: false,
                                                position: 'top',
                                                textStyle: {
                                                    color: '#5B90FA',
                                                    fontSize: xyTextSize
                                                }
                                            }
                                        }
                                    },
                                    barWidth: 20,
                                    emphasis: {
                                        focus: 'series'
                                    },
                                    data: data !== 'false' ? data : []
                                }
                            ]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 单柱图(横)
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} xData  x轴数据
                     * @param {*} colors  颜色数组
                     * @param {*} legendShow  是否显示图例
                     */
                    getTouZiJinDuOption(id, name, data, xData, colors, legendShow, textColor) {
                        if (!name) {
                            name = ''
                        }
                        // if (!data) {
                        //     data = []
                        // }
                        if (!colors) {
                            colors = ['#5b9bd5', '#ed7d31', '#a5a5a5', '#ffc003', '#4472c4', '#70ad47']
                        }
                        if (!legendShow) {
                            legendShow = false
                        }

                        let option = {
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    // 坐标轴指示器，坐标轴触发有效
                                    type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                                },
                                formatter: function (params) {
                                    return ` <span> ${params[0].name} </span><br/>
                                    <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params[0].color}"></span><span>${params[0].seriesName}</span><span>占比</span> ：
                                    <span>${params[0].value} </span>%<br/>`
                                }
                            },
                            grid: {
                                left: data !== 'false' ? '1%' : '10%',
                                right: '4%',
                                bottom: '6%',
                                top: '12%',
                                containLabel: true
                            },
                            legend: {
                                show: legendShow,
                                data: name,
                                right: '20',
                                textStyle: {
                                    fontSize: xyTextSize
                                }
                            },
                            xAxis: [
                                {
                                    // max: 100,
                                    type: 'value',
                                    splitLine: {
                                        show: false
                                    },
                                    axisLabel: {
                                        textStyle: {
                                            fontSize: xyTextSize,
                                            color: textColor ? textColor : xyTextColor
                                        }
                                    },
                                    axisLine: {
                                        lineStyle: {
                                            color: '#a9a9a9'
                                        }
                                    }
                                }
                            ],
                            yAxis: [
                                {
                                    name: '单位：%',
                                    type: 'category',
                                    data: xData,
                                    axisLabel: {
                                        textStyle: {
                                            fontSize: xyTextSize,
                                            color: textColor ? textColor : xyTextColor
                                        }
                                    },
                                    axisLine: {
                                        lineStyle: {
                                            color: '#a9a9a9'
                                        }
                                    },
                                    interval: 0
                                }
                            ],
                            series: [
                                {
                                    name: data !== 'false' ? name : '',
                                    type: 'bar',
                                    stack: '产量',
                                    itemStyle: {
                                        normal: {
                                            color: '#30D775',
                                            label: {
                                                show: false,
                                                position: 'top',
                                                textStyle: {
                                                    color: '#5B90FA',
                                                    fontSize: xyTextSize
                                                }
                                            }
                                        }
                                    },
                                    barWidth: 20,
                                    emphasis: {
                                        focus: 'series'
                                    },
                                    showBackground: true,
                                    backgroundStyle: {
                                        color: 'rgba(180, 180, 180, 0.2)'
                                    },
                                    data: data !== 'false' ? data : []
                                }
                            ]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 饼图
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} colors  颜色数组
                     */
                    getPicPicOption: function (id, name, data, colors) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!colors) {
                            colors = ['#6ce7df', '#fdd63d', '#ffae02', '#ff7877', '#ff94c2', '#764fce', '#007ed4', '#2297ff', '#35bbff']
                        }
                        var option = {
                            color: colors,
                            legend: {
                                show: false
                            },
                            grid: {
                                left: '3%',
                                right: '3%',
                                bottom: '2%',
                                top: '1%',
                                containLabel: true
                            },
                            series: [
                                {
                                    name: '',
                                    type: 'pie',
                                    radius: '50%',
                                    // center: center,
                                    hoverAnimation: false,
                                    labelLine: {
                                        show: false
                                    },
                                    data: [{ value: data }, { value: 100 }]
                                }
                            ]
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                    /**
                     * 水球图(三层波浪)
                     * @param {*} id  id
                     * @param {*} name  series名称
                     * @param {*} data  数据
                     * @param {*} legendShow  是否显示图例
                     */
                    getWaterPoloOption1(id, name, data, tabTypeDf, iftxtcolor,) {
                        if (!name) {
                            name = ''
                        }
                        if (!data) {
                            data = []
                        }
                        if (!iftxtcolor) {
                            iftxtcolor = false
                        }

                        var seriesData = []
                        data.map(item => {
                            var str = {
                                type: 'liquidFill',
                                data: [item.value / 100, item.value / 100 - 0.1, item.value / 100 - 0.2],
                                radius: item.radius,
                                center: item.center,
                                color: ['rgba(' + item.color + ', .5)', 'rgba(' + item.color + ', .7)', 'rgba(' + item.color + ', 1)'],
                                backgroundStyle: {
                                    borderWidth: 2,
                                    borderColor: 'rgba(' + item.color + ', 1)',
                                    shadowBlur: 0,
                                    shadowColor: 'rgba(' + item.color + ', 1)',
                                    color: 'transparent'
                                },
                                itemStyle: {
                                    shadowBlur: 0,
                                    shadowColor: 'rgba(' + item.color + ', 1)'
                                },
                                outline: {
                                    show: false
                                },
                                label: {
                                    fontSize: xyTextSize,
                                    position: id === 'WaterPoloEcharts' ? (clientWidth > 1025 ? ['50%', '80%'] : ['50%', '80%']) : ['50%', '80%'],
                                    formatter: () => {
                                        if (id === 'WaterPoloEcharts') {
                                            if (clientWidth > 1025) {
                                                return item.name + '\n' + (item.heart).toFixed(2) + '\n\n\n\n' + item.value + '%'
                                            } else {
                                                return item.name + '\n' + (item.heart).toFixed(2) + '\n\n' + item.value + '%'
                                            }
                                        } else {
                                            return item.name + '\n' + (item.heart).toFixed(2) + '\n\n\n\n' + item.value + '%'
                                        }
                                    },
                                    color: iftxtcolor ? darkColor : xyTextColor
                                }
                            }
                            seriesData.push(str)
                        })

                        let option = {
                            title: {
                                text: `单位：${tabTypeDf === 0 ? '万吨标煤' : '万吨CO₂'}`,
                                left: 'left',
                                top: clientWidth > 1025 ? '-1%' : '-3%',
                                textStyle: {
                                    fontSize: xyTextSize,
                                    color: iftxtcolor ? darkColor : xyTextColor
                                }
                            },
                            series: seriesData
                        }

                        this.chart = echarts.init(document.getElementById(id))
                        this.chart.clear()
                        this.chart.setOption(option)

                        return this.chart
                    },
                }
            }
        }
    })
}

export default {
    install
}



// WEBPACK FOOTER //
// ./src/utils/echartsOption.js